import * as React from "react";
export const FacilityBillCardIcon = (props) => (
  <svg
    id="Component_31_1"
    data-name="Component 31 \u2013 1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    // width={388}
    height={438}
    viewBox="0 0 388 438"
    {...props}
  >
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rectangle_56374"
          data-name="Rectangle 56374"
          width={388}
          height={438}
          rx={16}
          transform="translate(1064 160)"
          fill="none"
          stroke="#e4e8ee"
          strokeWidth={1}
        />
      </clipPath>
    </defs>
    <g
      id="Rectangle_53166"
      data-name="Rectangle 53166"
      fill="#fff"
      stroke="#e4e8ee"
      strokeWidth={1}
    >
      <rect width={388} height={438} rx={16} stroke="none" />
      <rect x={0.5} y={0.5} width={387} height={437} rx={15.5} fill="none" />
    </g>
    <g id="Group_96940" data-name="Group 96940">
      <g
        id="Mask_Group_6495"
        data-name="Mask Group 6495"
        transform="translate(-1064 -160)"
        opacity={0.5}
        clipPath="url(#clip-path)"
      >
        <g
          id="Group_110784"
          data-name="Group 110784"
          transform="translate(-8785.5 -8349.712)"
        >
          <path
            id="Path_100822"
            data-name="Path 100822"
            d="M0,0V456.479"
            transform="translate(9850.5 8499.712)"
            fill="none"
            stroke="#e4e8ee"
            strokeWidth={1}
          />
          <path
            id="Path_100821"
            data-name="Path 100821"
            d="M0,0V386.155"
            transform="translate(10237 8536.49) rotate(90)"
            fill="none"
            stroke="#e4e8ee"
            strokeWidth={1}
          />
          <path
            id="Path_100820"
            data-name="Path 100820"
            d="M0,0V456.479"
            transform="translate(10071.357 8499.712)"
            fill="none"
            stroke="#e4e8ee"
            strokeWidth={1}
          />
          <path
            id="Path_100819"
            data-name="Path 100819"
            d="M0,0V386.155"
            transform="translate(10237 8757.348) rotate(90)"
            fill="none"
            stroke="#e4e8ee"
            strokeWidth={1}
          />
          <path
            id="Path_100818"
            data-name="Path 100818"
            d="M0,0V456.479"
            transform="translate(9960.929 8499.712)"
            fill="none"
            stroke="#e4e8ee"
            strokeWidth={1}
          />
          <path
            id="Path_100817"
            data-name="Path 100817"
            d="M0,0V386.155"
            transform="translate(10237 8646.919) rotate(90)"
            fill="none"
            stroke="#e4e8ee"
            strokeWidth={1}
          />
          <path
            id="Path_100816"
            data-name="Path 100816"
            d="M0,0V456.479"
            transform="translate(10181.786 8499.712)"
            fill="none"
            stroke="#e4e8ee"
            strokeWidth={1}
          />
          <path
            id="Path_100815"
            data-name="Path 100815"
            d="M0,0V386.155"
            transform="translate(10237 8867.776) rotate(90)"
            fill="none"
            stroke="#e4e8ee"
            strokeWidth={1}
          />
          <path
            id="Path_100814"
            data-name="Path 100814"
            d="M0,0V456.479"
            transform="translate(9905.714 8499.712)"
            fill="none"
            stroke="#e4e8ee"
            strokeWidth={1}
          />
          <path
            id="Path_100813"
            data-name="Path 100813"
            d="M0,0V386.155"
            transform="translate(10237 8591.704) rotate(90)"
            fill="none"
            stroke="#e4e8ee"
            strokeWidth={1}
          />
          <path
            id="Path_100812"
            data-name="Path 100812"
            d="M0,0V456.479"
            transform="translate(10126.571 8499.712)"
            fill="none"
            stroke="#e4e8ee"
            strokeWidth={1}
          />
          <path
            id="Path_100811"
            data-name="Path 100811"
            d="M0,0V386.155"
            transform="translate(10237 8812.562) rotate(90)"
            fill="none"
            stroke="#e4e8ee"
            strokeWidth={1}
          />
          <path
            id="Path_100810"
            data-name="Path 100810"
            d="M0,0V456.479"
            transform="translate(10016.143 8499.712)"
            fill="none"
            stroke="#e4e8ee"
            strokeWidth={1}
          />
          <path
            id="Path_100809"
            data-name="Path 100809"
            d="M0,0V386.155"
            transform="translate(10237 8702.133) rotate(90)"
            fill="none"
            stroke="#e4e8ee"
            strokeWidth={1}
          />
          <path
            id="Path_100808"
            data-name="Path 100808"
            d="M0,0V456.479"
            transform="translate(10237 8499.712)"
            fill="none"
            stroke="#e4e8ee"
            strokeWidth={1}
          />
          <path
            id="Path_100807"
            data-name="Path 100807"
            d="M0,0V386.155"
            transform="translate(10237 8922.99) rotate(90)"
            fill="none"
            stroke="#e4e8ee"
            strokeWidth={1}
          />
        </g>
      </g>
      <text
        id="_"
        data-name=" "
        transform="translate(74 54)"
        fill="#4e5a6b"
        fontSize={12}
        fontFamily="system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI',  'NotoSans-Regular'"
        letterSpacing="-0.008em"
      >
        <tspan x={0} y={0} />
      </text>
      <g
        id="Group_110749"
        data-name="Group 110749"
        transform="translate(27.582 20.921)"
      >
        <g
          id="Group_110783"
          data-name="Group 110783"
          transform="translate(70.419 73.063)"
        >
          <g
            id="Group_110749-2"
            data-name="Group 110749"
            transform="translate(37.972 44.97)"
          >
            <path
              id="Path_100146"
              data-name="Path 100146"
              d="M136.71,147.971v-.981a.915.915,0,0,0-.915-.915h0a.915.915,0,0,0-.915.915v.981a.915.915,0,0,1-.915.915h-.981a.915.915,0,0,0-.915.915h0a.915.915,0,0,0,.915.915h.981a.915.915,0,0,1,.915.915v.981a.915.915,0,0,0,.915.915h0a.915.915,0,0,0,.915-.915v-.981a.915.915,0,0,1,.915-.915h.981a.915.915,0,0,0,.915-.915h0a.915.915,0,0,0-.915-.915h-.981A.915.915,0,0,1,136.71,147.971Z"
              transform="translate(-132.069 -146.075)"
              fill="#ced3dd"
            />
          </g>
          <g
            id="Group_110750"
            data-name="Group 110750"
            transform="translate(6.617 85.312)"
          >
            <path
              id="Path_100147"
              data-name="Path 100147"
              d="M84.2,212.81v-.641a.6.6,0,0,0-.6-.6h0a.6.6,0,0,0-.6.6v.641a.6.6,0,0,1-.6.6H81.76a.6.6,0,0,0-.6.6h0a.6.6,0,0,0,.6.6H82.4a.6.6,0,0,1,.6.6v.641a.6.6,0,0,0,.6.6h0a.6.6,0,0,0,.6-.6V215.2a.6.6,0,0,1,.6-.6h.641a.6.6,0,0,0,.6-.6h0a.6.6,0,0,0-.6-.6h-.641A.6.6,0,0,1,84.2,212.81Z"
              transform="translate(-81.162 -211.571)"
              fill="#ced3dd"
            />
          </g>
          <g
            id="Group_110751"
            data-name="Group 110751"
            transform="translate(147.628 64.32)"
          >
            <path
              id="Path_100148"
              data-name="Path 100148"
              d="M313.136,178.73v-.641a.6.6,0,0,0-.6-.6h0a.6.6,0,0,0-.6.6v.641a.6.6,0,0,1-.6.6H310.7a.6.6,0,0,0-.6.6h0a.6.6,0,0,0,.6.6h.641a.6.6,0,0,1,.6.6v.641a.6.6,0,0,0,.6.6h0a.6.6,0,0,0,.6-.6v-.641a.6.6,0,0,1,.6-.6h.641a.6.6,0,0,0,.6-.6h0a.6.6,0,0,0-.6-.6h-.641A.6.6,0,0,1,313.136,178.73Z"
              transform="translate(-310.101 -177.49)"
              fill="#ced3dd"
            />
          </g>
          <g
            id="Group_110752"
            data-name="Group 110752"
            transform="translate(22.538 125.623)"
          >
            <path
              id="Path_100149"
              data-name="Path 100149"
              d="M109.485,278.03v-.523a.488.488,0,0,0-.488-.488h0a.488.488,0,0,0-.488.488v.523a.488.488,0,0,1-.488.488H107.5a.488.488,0,0,0-.488.488h0a.488.488,0,0,0,.488.488h.523a.488.488,0,0,1,.488.488v.523a.488.488,0,0,0,.488.488h0a.488.488,0,0,0,.488-.488v-.523a.488.488,0,0,1,.488-.488h.524a.488.488,0,0,0,.488-.488h0a.488.488,0,0,0-.488-.488h-.524A.488.488,0,0,1,109.485,278.03Z"
              transform="translate(-107.01 -277.019)"
              fill="#ced3dd"
            />
          </g>
          <g
            id="Group_110753"
            data-name="Group 110753"
            transform="translate(161.746 99.533)"
          >
            <path
              id="Path_100150"
              data-name="Path 100150"
              d="M335.5,235.672v-.523a.488.488,0,0,0-.488-.488h0a.488.488,0,0,0-.488.488v.523a.487.487,0,0,1-.488.488h-.523a.488.488,0,0,0-.488.488h0a.488.488,0,0,0,.488.488h.523a.488.488,0,0,1,.488.488v.523a.488.488,0,0,0,.488.488h0a.488.488,0,0,0,.488-.488v-.523a.488.488,0,0,1,.488-.488h.523a.488.488,0,0,0,.488-.488h0a.488.488,0,0,0-.488-.488h-.523A.488.488,0,0,1,335.5,235.672Z"
              transform="translate(-333.022 -234.661)"
              fill="#ced3dd"
            />
          </g>
          <circle
            id="Ellipse_129678"
            data-name="Ellipse 129678"
            cx={1.732}
            cy={1.732}
            r={1.732}
            transform="translate(32.051 101.095)"
            fill="#ced3dd"
          />
          <circle
            id="Ellipse_129679"
            data-name="Ellipse 129679"
            cx={1.732}
            cy={1.732}
            r={1.732}
            transform="translate(167.862 51.878)"
            fill="#ced3dd"
          />
          <path
            id="Path_100151"
            data-name="Path 100151"
            d="M138.11,201.484a.945.945,0,1,1-.945-.945A.945.945,0,0,1,138.11,201.484Z"
            transform="translate(-95.691 -122.022)"
            fill="#ced3dd"
          />
          <path
            id="Path_100152"
            data-name="Path 100152"
            d="M104.114,180.457a1.255,1.255,0,1,1-1.255-1.255A1.256,1.256,0,0,1,104.114,180.457Z"
            transform="translate(-82.396 -113.828)"
            fill="#ced3dd"
          />
          <circle
            id="Ellipse_129680"
            data-name="Ellipse 129680"
            cx={1.255}
            cy={1.255}
            r={1.255}
            transform="translate(144.948 89.165)"
            fill="#ced3dd"
          />
          <g
            id="Ellipse_129681"
            data-name="Ellipse 129681"
            transform="translate(41.897 142.336)"
            fill="none"
            stroke="#ced3dd"
            strokeMiterlimit={10}
            strokeWidth={1}
          >
            <circle cx={1.575} cy={1.575} r={1.575} stroke="none" />
            <circle cx={1.575} cy={1.575} r={1.075} fill="none" />
          </g>
          <g
            id="Path_100153"
            data-name="Path 100153"
            transform="translate(-76.208 -168.443)"
            fill="none"
            strokeMiterlimit={10}
          >
            <path
              d="M89.511,323.415a2.01,2.01,0,1,1-2.01-2.01A2.01,2.01,0,0,1,89.511,323.415Z"
              stroke="none"
            />
            <path
              d="M 87.50077819824219 322.4049987792969 C 86.94398498535156 322.4049987792969 86.49099731445312 322.8579711914062 86.49099731445312 323.414794921875 C 86.49099731445312 323.9715881347656 86.94398498535156 324.424560546875 87.50077819824219 324.424560546875 C 88.05758666992188 324.424560546875 88.51057434082031 323.9715881347656 88.51057434082031 323.414794921875 C 88.51057434082031 322.8579711914062 88.05758666992188 322.4049987792969 87.50077819824219 322.4049987792969 M 87.50077819824219 321.4049987792969 C 88.61069488525391 321.4049987792969 89.51057434082031 322.3048706054688 89.51057434082031 323.414794921875 C 89.51057434082031 324.5246887207031 88.61069488525391 325.424560546875 87.50077819824219 325.424560546875 C 86.39087677001953 325.424560546875 85.49099731445312 324.5246887207031 85.49099731445312 323.414794921875 C 85.49099731445312 322.3048706054688 86.39087677001953 321.4049987792969 87.50077819824219 321.4049987792969 Z"
              stroke="none"
              fill="#e4e8ee"
            />
          </g>
          <g
            id="Path_100154"
            data-name="Path 100154"
            transform="translate(-175.311 -120.511)"
            fill="none"
            strokeMiterlimit={10}
          >
            <path
              d="M347.548,198.613a2.01,2.01,0,1,1-2.01-2.01A2.009,2.009,0,0,1,347.548,198.613Z"
              stroke="none"
            />
            <path
              d="M 345.5377807617188 199.6219482421875 C 346.0945739746094 199.6219482421875 346.5475463867188 199.1692352294922 346.5475463867188 198.6127777099609 C 346.5475463867188 198.0559844970703 346.0945739746094 197.6029968261719 345.5377807617188 197.6029968261719 C 344.9809875488281 197.6029968261719 344.5280151367188 198.0559844970703 344.5280151367188 198.6127777099609 C 344.5280151367188 199.1692352294922 344.9809875488281 199.6219482421875 345.5377807617188 199.6219482421875 M 345.5377807617188 200.6219482421875 C 344.4278869628906 200.6219482421875 343.5280151367188 199.7226867675781 343.5280151367188 198.6127777099609 C 343.5280151367188 197.5028686523438 344.4278869628906 196.6029968261719 345.5377807617188 196.6029968261719 C 346.647705078125 196.6029968261719 347.5475463867188 197.5028686523438 347.5475463867188 198.6127777099609 C 347.5475463867188 199.7226867675781 346.647705078125 200.6219482421875 345.5377807617188 200.6219482421875 Z"
              stroke="none"
              fill="#e4e8ee"
            />
          </g>
          <g
            id="Path_100155"
            data-name="Path 100155"
            transform="translate(-84.862 -93.201)"
            fill="none"
            strokeMiterlimit={10}
          >
            <path
              d="M111.191,129.15a2.01,2.01,0,1,1,.488-2.8A2.009,2.009,0,0,1,111.191,129.15Z"
              stroke="none"
            />
            <path
              d="M 110.0368347167969 128.515380859375 C 110.2445907592773 128.515380859375 110.4449005126953 128.4517822265625 110.6160202026367 128.3315124511719 C 111.0715255737305 128.0112609863281 111.1816253662109 127.3801193237305 110.8616943359375 126.9249420166016 C 110.6725845336914 126.656135559082 110.3630905151367 126.4956588745117 110.0337677001953 126.4956588745117 C 109.8261489868164 126.4956588745117 109.6259841918945 126.5592651367188 109.4545669555664 126.6798706054688 C 109.2340393066406 126.8348693847656 109.0870971679688 127.0664749145508 109.0408172607422 127.3320388793945 C 108.994499206543 127.597770690918 109.0545043945312 127.8657455444336 109.2098770141602 128.0867309570312 C 109.3985290527344 128.3551483154297 109.7076644897461 128.515380859375 110.0368347167969 128.515380859375 M 110.0368347167969 129.515380859375 C 109.40478515625 129.515380859375 108.7827529907227 129.2180938720703 108.3917388916016 128.6617584228516 C 107.7530059814453 127.7532501220703 107.9716644287109 126.4998245239258 108.8795471191406 125.8617248535156 C 109.7874069213867 125.2229919433594 111.0408554077148 125.4416732788086 111.6795806884766 126.3495483398438 C 112.3176879882812 127.2574310302734 112.0996398925781 128.5108642578125 111.1911468505859 129.1495666503906 C 110.8396072387695 129.3966522216797 110.4362030029297 129.515380859375 110.0368347167969 129.515380859375 Z"
              stroke="none"
              fill="#e4e8ee"
            />
          </g>
          <g id="Group_110782" data-name="Group 110782">
            <g id="Group_110781" data-name="Group 110781">
              <g id="Group_110760" data-name="Group 110760">
                <path
                  id="Path_100165"
                  data-name="Path 100165"
                  d="M347.579,100.569v10.716H336.965l-.128-.128-.128.128H319.574l-.089-.089-.09.089h-9.22l-.345-.345-.346.345H302.63l-.038-.038-.039.038h-6.33l-.025-.025-.026.025h-3.606V100.569a27.507,27.507,0,0,1,55.013,0Z"
                  transform="translate(-155.738 -73.063)"
                  fill="#e4e8ee"
                />
                <g id="Group_110759" data-name="Group 110759">
                  <g id="Group_110758" data-name="Group 110758">
                    <path
                      id="Path_100166"
                      data-name="Path 100166"
                      d="M275.44,376.447a27.159,27.159,0,0,1-27.076,25.389h-.179a27.509,27.509,0,0,0,27.255-25.389Z"
                      transform="translate(-138.693 -189.583)"
                      fill="#e3f1fc"
                    />
                    <path
                      id="Path_100167"
                      data-name="Path 100167"
                      d="M187.252,73.063a27.506,27.506,0,0,0-27.519,27.506V247.1h27.155v10.715a27.329,27.329,0,0,0,54.581,2.116c.051-.693.079-1.4.079-2.116l0-157.242a27.506,27.506,0,0,1,27.507-27.506Z"
                      transform="translate(-104.721 -73.063)"
                      fill="#f5f7fa"
                    />
                    <path
                      id="Path_100168"
                      data-name="Path 100168"
                      d="M160.64,385.781a27.423,27.423,0,0,1-8.056-19.45V355.616H121.827l-.029.022-.021-.022h-6.334l-.036.036-.042-.036H70.419v10.715a27.5,27.5,0,0,0,27.505,27.505h81.987A27.434,27.434,0,0,1,160.64,385.781Z"
                      transform="translate(-70.419 -181.582)"
                      fill="#e4e8ee"
                    />
                  </g>
                </g>
              </g>
              <g
                id="Group_110780"
                data-name="Group 110780"
                transform="translate(62.166 26.487)"
              >
                <g
                  id="Group_110763"
                  data-name="Group 110763"
                  transform="translate(0 39.509)"
                >
                  <g id="Group_110761" data-name="Group 110761">
                    <rect
                      id="Rectangle_56349"
                      data-name="Rectangle 56349"
                      width={26.656}
                      height={2.813}
                      fill="#e4e8ee"
                    />
                    <rect
                      id="Rectangle_56350"
                      data-name="Rectangle 56350"
                      width={17.911}
                      height={2.813}
                      transform="translate(0 9.182)"
                      fill="#e4e8ee"
                    />
                    <rect
                      id="Rectangle_56351"
                      data-name="Rectangle 56351"
                      width={23.808}
                      height={2.813}
                      transform="translate(0 18.364)"
                      fill="#e4e8ee"
                    />
                    <rect
                      id="Rectangle_56352"
                      data-name="Rectangle 56352"
                      width={30.599}
                      height={2.813}
                      transform="translate(0 27.546)"
                      fill="#e4e8ee"
                    />
                    <rect
                      id="Rectangle_56353"
                      data-name="Rectangle 56353"
                      width={26.656}
                      height={2.813}
                      transform="translate(0 55.093)"
                      fill="#e4e8ee"
                    />
                    <rect
                      id="Rectangle_56354"
                      data-name="Rectangle 56354"
                      width={9.366}
                      height={2.813}
                      transform="translate(0 64.275)"
                      fill="#e4e8ee"
                    />
                    <rect
                      id="Rectangle_56355"
                      data-name="Rectangle 56355"
                      width={48.537}
                      height={2.813}
                      transform="translate(0 36.729)"
                      fill="#e4e8ee"
                    />
                    <rect
                      id="Rectangle_56356"
                      data-name="Rectangle 56356"
                      width={22.572}
                      height={2.813}
                      transform="translate(0 45.911)"
                      fill="#e4e8ee"
                    />
                  </g>
                  <g id="Group_110762" data-name="Group 110762">
                    <rect
                      id="Rectangle_56357"
                      data-name="Rectangle 56357"
                      width={9.37}
                      height={2.813}
                      transform="translate(57.826)"
                      fill="#e4e8ee"
                    />
                    <rect
                      id="Rectangle_56358"
                      data-name="Rectangle 56358"
                      width={6.716}
                      height={2.813}
                      transform="translate(60.48 9.182)"
                      fill="#e4e8ee"
                    />
                    <rect
                      id="Rectangle_56359"
                      data-name="Rectangle 56359"
                      width={9.37}
                      height={2.813}
                      transform="translate(57.826 18.364)"
                      fill="#e4e8ee"
                    />
                    <rect
                      id="Rectangle_56360"
                      data-name="Rectangle 56360"
                      width={9.37}
                      height={2.813}
                      transform="translate(57.826 27.546)"
                      fill="#e4e8ee"
                    />
                    <rect
                      id="Rectangle_56361"
                      data-name="Rectangle 56361"
                      width={6.716}
                      height={2.813}
                      transform="translate(60.48 55.093)"
                      fill="#e4e8ee"
                    />
                    <rect
                      id="Rectangle_56362"
                      data-name="Rectangle 56362"
                      width={9.37}
                      height={2.813}
                      transform="translate(57.826 64.275)"
                      fill="#e4e8ee"
                    />
                    <rect
                      id="Rectangle_56363"
                      data-name="Rectangle 56363"
                      width={6.716}
                      height={2.813}
                      transform="translate(60.48 36.729)"
                      fill="#e4e8ee"
                    />
                    <rect
                      id="Rectangle_56364"
                      data-name="Rectangle 56364"
                      width={9.37}
                      height={2.813}
                      transform="translate(57.826 45.911)"
                      fill="#e4e8ee"
                    />
                    <rect
                      id="Rectangle_56365"
                      data-name="Rectangle 56365"
                      width={26.656}
                      height={2.813}
                      transform="translate(0 82.119)"
                      fill="#e4e8ee"
                    />
                    <rect
                      id="Rectangle_56366"
                      data-name="Rectangle 56366"
                      width={9.366}
                      height={4.66}
                      transform="translate(0 91.302)"
                      fill="#e4e8ee"
                    />
                    <rect
                      id="Rectangle_56367"
                      data-name="Rectangle 56367"
                      width={22.572}
                      height={2.813}
                      transform="translate(0 72.937)"
                      fill="#e4e8ee"
                    />
                    <rect
                      id="Rectangle_56368"
                      data-name="Rectangle 56368"
                      width={6.716}
                      height={2.813}
                      transform="translate(60.48 82.119)"
                      fill="#e4e8ee"
                    />
                    <rect
                      id="Rectangle_56369"
                      data-name="Rectangle 56369"
                      width={9.37}
                      height={4.66}
                      transform="translate(57.826 91.302)"
                      fill="#e4e8ee"
                    />
                    <rect
                      id="Rectangle_56370"
                      data-name="Rectangle 56370"
                      width={9.37}
                      height={2.813}
                      transform="translate(57.826 72.937)"
                      fill="#e4e8ee"
                    />
                  </g>
                </g>
                <g
                  id="Group_110764"
                  data-name="Group 110764"
                  transform="translate(9.893)"
                >
                  <rect
                    id="Rectangle_56371"
                    data-name="Rectangle 56371"
                    width={35.598}
                    height={3.365}
                    transform="translate(6.873 14.168)"
                    fill="#ced3dd"
                  />
                  <rect
                    id="Rectangle_56372"
                    data-name="Rectangle 56372"
                    width={22.23}
                    height={3.365}
                    transform="translate(13.557)"
                    fill="#ced3dd"
                  />
                  <rect
                    id="Rectangle_56373"
                    data-name="Rectangle 56373"
                    width={49.345}
                    height={3.365}
                    transform="translate(0 7.084)"
                    fill="#ced3dd"
                  />
                </g>
                <g
                  id="Group_110779"
                  data-name="Group 110779"
                  transform="translate(12.803 27.174)"
                >
                  <g id="Group_110765" data-name="Group 110765">
                    <line
                      id="Line_1892"
                      data-name="Line 1892"
                      x2={1.408}
                      y2={1.408}
                      fill="none"
                      stroke="#e4e8ee"
                      strokeLinecap="round"
                      strokeMiterlimit={10}
                      strokeWidth={0.86}
                    />
                    <line
                      id="Line_1893"
                      data-name="Line 1893"
                      x1={1.408}
                      y2={1.408}
                      fill="none"
                      stroke="#e4e8ee"
                      strokeLinecap="round"
                      strokeMiterlimit={10}
                      strokeWidth={0.86}
                    />
                  </g>
                  <g
                    id="Group_110766"
                    data-name="Group 110766"
                    transform="translate(41.954)"
                  >
                    <line
                      id="Line_1894"
                      data-name="Line 1894"
                      x2={1.408}
                      y2={1.408}
                      fill="none"
                      stroke="#e4e8ee"
                      strokeLinecap="round"
                      strokeMiterlimit={10}
                      strokeWidth={0.86}
                    />
                    <line
                      id="Line_1895"
                      data-name="Line 1895"
                      x1={1.408}
                      y2={1.408}
                      fill="none"
                      stroke="#e4e8ee"
                      strokeLinecap="round"
                      strokeMiterlimit={10}
                      strokeWidth={0.86}
                    />
                  </g>
                  <g
                    id="Group_110767"
                    data-name="Group 110767"
                    transform="translate(35.5)"
                  >
                    <line
                      id="Line_1896"
                      data-name="Line 1896"
                      x2={1.408}
                      y2={1.408}
                      fill="none"
                      stroke="#e4e8ee"
                      strokeLinecap="round"
                      strokeMiterlimit={10}
                      strokeWidth={0.86}
                    />
                    <line
                      id="Line_1897"
                      data-name="Line 1897"
                      x1={1.408}
                      y2={1.408}
                      fill="none"
                      stroke="#e4e8ee"
                      strokeLinecap="round"
                      strokeMiterlimit={10}
                      strokeWidth={0.86}
                    />
                  </g>
                  <g
                    id="Group_110768"
                    data-name="Group 110768"
                    transform="translate(32.273)"
                  >
                    <line
                      id="Line_1898"
                      data-name="Line 1898"
                      x2={1.408}
                      y2={1.408}
                      fill="none"
                      stroke="#e4e8ee"
                      strokeLinecap="round"
                      strokeMiterlimit={10}
                      strokeWidth={0.86}
                    />
                    <line
                      id="Line_1899"
                      data-name="Line 1899"
                      x1={1.408}
                      y2={1.408}
                      fill="none"
                      stroke="#e4e8ee"
                      strokeLinecap="round"
                      strokeMiterlimit={10}
                      strokeWidth={0.86}
                    />
                  </g>
                  <g
                    id="Group_110769"
                    data-name="Group 110769"
                    transform="translate(29.045)"
                  >
                    <line
                      id="Line_1900"
                      data-name="Line 1900"
                      x2={1.408}
                      y2={1.408}
                      fill="none"
                      stroke="#e4e8ee"
                      strokeLinecap="round"
                      strokeMiterlimit={10}
                      strokeWidth={0.86}
                    />
                    <line
                      id="Line_1901"
                      data-name="Line 1901"
                      x1={1.408}
                      y2={1.408}
                      fill="none"
                      stroke="#e4e8ee"
                      strokeLinecap="round"
                      strokeMiterlimit={10}
                      strokeWidth={0.86}
                    />
                  </g>
                  <g
                    id="Group_110770"
                    data-name="Group 110770"
                    transform="translate(25.818)"
                  >
                    <line
                      id="Line_1902"
                      data-name="Line 1902"
                      x2={1.408}
                      y2={1.408}
                      fill="none"
                      stroke="#e4e8ee"
                      strokeLinecap="round"
                      strokeMiterlimit={10}
                      strokeWidth={0.86}
                    />
                    <line
                      id="Line_1903"
                      data-name="Line 1903"
                      x1={1.408}
                      y2={1.408}
                      fill="none"
                      stroke="#e4e8ee"
                      strokeLinecap="round"
                      strokeMiterlimit={10}
                      strokeWidth={0.86}
                    />
                  </g>
                  <g
                    id="Group_110771"
                    data-name="Group 110771"
                    transform="translate(22.591)"
                  >
                    <line
                      id="Line_1904"
                      data-name="Line 1904"
                      x2={1.408}
                      y2={1.408}
                      fill="none"
                      stroke="#e4e8ee"
                      strokeLinecap="round"
                      strokeMiterlimit={10}
                      strokeWidth={0.86}
                    />
                    <line
                      id="Line_1905"
                      data-name="Line 1905"
                      x1={1.408}
                      y2={1.408}
                      fill="none"
                      stroke="#e4e8ee"
                      strokeLinecap="round"
                      strokeMiterlimit={10}
                      strokeWidth={0.86}
                    />
                  </g>
                  <g
                    id="Group_110772"
                    data-name="Group 110772"
                    transform="translate(38.727)"
                  >
                    <line
                      id="Line_1906"
                      data-name="Line 1906"
                      x2={1.408}
                      y2={1.408}
                      fill="none"
                      stroke="#e4e8ee"
                      strokeLinecap="round"
                      strokeMiterlimit={10}
                      strokeWidth={0.86}
                    />
                    <line
                      id="Line_1907"
                      data-name="Line 1907"
                      x1={1.408}
                      y2={1.408}
                      fill="none"
                      stroke="#e4e8ee"
                      strokeLinecap="round"
                      strokeMiterlimit={10}
                      strokeWidth={0.86}
                    />
                  </g>
                  <g
                    id="Group_110773"
                    data-name="Group 110773"
                    transform="translate(16.136)"
                  >
                    <line
                      id="Line_1908"
                      data-name="Line 1908"
                      x2={1.408}
                      y2={1.408}
                      fill="none"
                      stroke="#e4e8ee"
                      strokeLinecap="round"
                      strokeMiterlimit={10}
                      strokeWidth={0.86}
                    />
                    <line
                      id="Line_1909"
                      data-name="Line 1909"
                      x1={1.408}
                      y2={1.408}
                      fill="none"
                      stroke="#e4e8ee"
                      strokeLinecap="round"
                      strokeMiterlimit={10}
                      strokeWidth={0.86}
                    />
                  </g>
                  <g
                    id="Group_110774"
                    data-name="Group 110774"
                    transform="translate(12.909)"
                  >
                    <line
                      id="Line_1910"
                      data-name="Line 1910"
                      x2={1.408}
                      y2={1.408}
                      fill="none"
                      stroke="#e4e8ee"
                      strokeLinecap="round"
                      strokeMiterlimit={10}
                      strokeWidth={0.86}
                    />
                    <line
                      id="Line_1911"
                      data-name="Line 1911"
                      x1={1.408}
                      y2={1.408}
                      fill="none"
                      stroke="#e4e8ee"
                      strokeLinecap="round"
                      strokeMiterlimit={10}
                      strokeWidth={0.86}
                    />
                  </g>
                  <g
                    id="Group_110775"
                    data-name="Group 110775"
                    transform="translate(6.455)"
                  >
                    <line
                      id="Line_1912"
                      data-name="Line 1912"
                      x2={1.408}
                      y2={1.408}
                      fill="none"
                      stroke="#e4e8ee"
                      strokeLinecap="round"
                      strokeMiterlimit={10}
                      strokeWidth={0.86}
                    />
                    <line
                      id="Line_1913"
                      data-name="Line 1913"
                      x1={1.408}
                      y2={1.408}
                      fill="none"
                      stroke="#e4e8ee"
                      strokeLinecap="round"
                      strokeMiterlimit={10}
                      strokeWidth={0.86}
                    />
                  </g>
                  <g
                    id="Group_110776"
                    data-name="Group 110776"
                    transform="translate(3.227)"
                  >
                    <line
                      id="Line_1914"
                      data-name="Line 1914"
                      x2={1.408}
                      y2={1.408}
                      fill="none"
                      stroke="#e4e8ee"
                      strokeLinecap="round"
                      strokeMiterlimit={10}
                      strokeWidth={0.86}
                    />
                    <line
                      id="Line_1915"
                      data-name="Line 1915"
                      x1={1.408}
                      y2={1.408}
                      fill="none"
                      stroke="#e4e8ee"
                      strokeLinecap="round"
                      strokeMiterlimit={10}
                      strokeWidth={0.86}
                    />
                  </g>
                  <g
                    id="Group_110777"
                    data-name="Group 110777"
                    transform="translate(9.682)"
                  >
                    <line
                      id="Line_1916"
                      data-name="Line 1916"
                      x2={1.408}
                      y2={1.408}
                      fill="none"
                      stroke="#e4e8ee"
                      strokeLinecap="round"
                      strokeMiterlimit={10}
                      strokeWidth={0.86}
                    />
                    <line
                      id="Line_1917"
                      data-name="Line 1917"
                      x1={1.408}
                      y2={1.408}
                      fill="none"
                      stroke="#e4e8ee"
                      strokeLinecap="round"
                      strokeMiterlimit={10}
                      strokeWidth={0.86}
                    />
                  </g>
                  <g
                    id="Group_110778"
                    data-name="Group 110778"
                    transform="translate(19.364)"
                  >
                    <line
                      id="Line_1918"
                      data-name="Line 1918"
                      x2={1.408}
                      y2={1.408}
                      fill="none"
                      stroke="#e4e8ee"
                      strokeLinecap="round"
                      strokeMiterlimit={10}
                      strokeWidth={0.86}
                    />
                    <line
                      id="Line_1919"
                      data-name="Line 1919"
                      x1={1.408}
                      y2={1.408}
                      fill="none"
                      stroke="#e4e8ee"
                      strokeLinecap="round"
                      strokeMiterlimit={10}
                      strokeWidth={0.86}
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <ellipse
          id="Ellipse_129683"
          data-name="Ellipse 129683"
          cx={86.367}
          cy={4.541}
          rx={86.367}
          ry={4.541}
          transform="translate(89.527 292.011)"
          fill="#e4e8ee"
          opacity={0.47}
        />
      </g>
      <text
        id="Booking_Summary"
        data-name="Booking Summary"
        transform="translate(194 56)"
        fill="#4e5a6b"
        fontSize={16}
        fontFamily="system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI',  'NotoSans-ExtraBold'"
        fontWeight={700}
        letterSpacing="-0.008em"
      >
        <tspan x={-67.312} y={0}>
          {"Booking Summary"}
        </tspan>
      </text>
      <text
        id="Summary_will_be_added_once_the_facility_slot_is_selected"
        data-name="Summary will be added once the facility slot is selected"
        transform="translate(194 374)"
        fill="#98a0ac"
        fontSize={14}
        fontFamily="system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI',  'NotoSans-Regular'"
        letterSpacing="-0.008em"
      >
        <tspan x={-134.953} y={0}>
          {"Summary will be added once the facility slot"}
        </tspan>
        <tspan x={-32.095} y={19}>
          {"is selected"}
        </tspan>
      </text>
    </g>
  </svg>
);


// import * as React from "react"
// export const FacilityBillCardIcon = (props) => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     width={388}
//     height={438}
//     data-name="Group 116450"
//     {...props}
//   >
//     <defs>
//       <clipPath id="a">
//         <rect
//           width={388}
//           height={438}
//           fill="none"
//           stroke="#e4e8ee"
//           data-name="Rectangle 56374"
//           rx={16}
//           transform="translate(1064 160)"
//         />
//       </clipPath>
//     </defs>
//     <g fill="#fff" stroke="#e4e8ee" data-name="Rectangle 53166">
//       <rect width={388} height={438} stroke="none" rx={16} />
//       <rect width={387} height={437} x={0.5} y={0.5} fill="none" rx={15.5} />
//     </g>
//     <g data-name="Group 96940">
//       <g
//         clipPath="url(#a)"
//         data-name="Mask Group 6495"
//         opacity={0.5}
//         transform="translate(-1064 -160)"
//       >
//         <g data-name="Group 110784">
//           <path
//             fill="none"
//             stroke="#e4e8ee"
//             d="M1065 150v456.479"
//             data-name="Path 100822"
//           />
//           <path
//             fill="#e4e8ee"
//             d="M1065.345 187.278v-1H1451.5v1Z"
//             data-name="Path 100821"
//           />
//           <path
//             fill="#e4e8ee"
//             d="M1286.357 606.479h-1V150h1Z"
//             data-name="Path 100820"
//           />
//           <path
//             fill="#e4e8ee"
//             d="M1065.345 408.136v-1H1451.5v1Z"
//             data-name="Path 100819"
//           />
//           <path
//             fill="#e4e8ee"
//             d="M1175.929 606.479h-1V150h1Z"
//             data-name="Path 100818"
//           />
//           <path
//             fill="#e4e8ee"
//             d="M1065.345 297.707v-1H1451.5v1Z"
//             data-name="Path 100817"
//           />
//           <path
//             fill="#e4e8ee"
//             d="M1396.786 606.479h-1V150h1Z"
//             data-name="Path 100816"
//           />
//           <path
//             fill="#e4e8ee"
//             d="M1065.345 518.564v-1H1451.5v1Z"
//             data-name="Path 100815"
//           />
//           <path
//             fill="#e4e8ee"
//             d="M1120.714 606.479h-1V150h1Z"
//             data-name="Path 100814"
//           />
//           <path
//             fill="#e4e8ee"
//             d="M1065.345 242.492v-1H1451.5v1Z"
//             data-name="Path 100813"
//           />
//           <path
//             fill="#e4e8ee"
//             d="M1341.571 606.479h-1V150h1Z"
//             data-name="Path 100812"
//           />
//           <path
//             fill="#e4e8ee"
//             d="M1065.345 463.35v-1H1451.5v1Z"
//             data-name="Path 100811"
//           />
//           <path
//             fill="#e4e8ee"
//             d="M1231.143 606.479h-1V150h1Z"
//             data-name="Path 100810"
//           />
//           <path
//             fill="#e4e8ee"
//             d="M1065.345 352.921v-1H1451.5v1Z"
//             data-name="Path 100809"
//           />
//           <path
//             fill="none"
//             stroke="#e4e8ee"
//             d="M1451.5 150v456.479"
//             data-name="Path 100808"
//           />
//           <path
//             fill="#e4e8ee"
//             d="M1065.345 573.778v-1H1451.5v1Z"
//             data-name="Path 100807"
//           />
//         </g>
//       </g>
//       <text
//         fill="#4e5a6b"
//         fontFamily="NunitoSans-Regular, Nunito Sans"
//         fontSize={12}
//         letterSpacing="-.008em"
//         transform="translate(74 54)"
//       >
//         <tspan x={0} y={0} />
//       </text>
//       <text
//         fill="#091b29"
//         fontFamily="NunitoSans-Bold, Nunito Sans"
//         fontSize={14}
//         fontWeight={700}
//         letterSpacing="-.008em"
//         transform="translate(209 290)"
//       />
//       <g data-name="Group 110749" transform="translate(27.582 20.921)">
//         <g data-name="Group 110783" transform="translate(70.419 73.063)">
//           <g data-name="Group 110749">
//             <path
//               fill="#ced3dd"
//               d="M42.613 46.866v-.981a.915.915 0 0 0-.915-.915.915.915 0 0 0-.915.915v.981a.915.915 0 0 1-.915.915h-.981a.915.915 0 0 0-.915.915.915.915 0 0 0 .915.915h.981a.915.915 0 0 1 .915.915v.981a.915.915 0 0 0 .915.915.915.915 0 0 0 .915-.915v-.981a.915.915 0 0 1 .915-.915h.981a.915.915 0 0 0 .915-.915.915.915 0 0 0-.915-.915h-.981a.915.915 0 0 1-.915-.915Z"
//               data-name="Path 100146"
//             />
//           </g>
//           <g data-name="Group 110750">
//             <path
//               fill="#ced3dd"
//               d="M9.655 86.551v-.641a.6.6 0 0 0-.6-.6.6.6 0 0 0-.6.6v.641a.6.6 0 0 1-.6.6h-.64a.6.6 0 0 0-.6.6.6.6 0 0 0 .6.6h.64a.6.6 0 0 1 .6.6v.641a.6.6 0 0 0 .6.6.6.6 0 0 0 .6-.6v-.651a.6.6 0 0 1 .6-.6h.641a.6.6 0 0 0 .6-.6.6.6 0 0 0-.6-.6h-.641a.6.6 0 0 1-.6-.59Z"
//               data-name="Path 100147"
//             />
//           </g>
//           <g data-name="Group 110751">
//             <path
//               fill="#ced3dd"
//               d="M150.663 65.56v-.641a.6.6 0 0 0-.6-.6.6.6 0 0 0-.6.6v.641a.6.6 0 0 1-.6.6h-.636a.6.6 0 0 0-.6.6.6.6 0 0 0 .6.6h.641a.6.6 0 0 1 .6.6v.641a.6.6 0 0 0 .6.6.6.6 0 0 0 .6-.6v-.641a.6.6 0 0 1 .6-.6h.641a.6.6 0 0 0 .6-.6.6.6 0 0 0-.6-.6h-.641a.6.6 0 0 1-.605-.6Z"
//               data-name="Path 100148"
//             />
//           </g>
//           <g data-name="Group 110752">
//             <path
//               fill="#ced3dd"
//               d="M25.013 126.634v-.523a.488.488 0 0 0-.488-.488.488.488 0 0 0-.488.488v.523a.488.488 0 0 1-.488.488h-.521a.488.488 0 0 0-.488.488.488.488 0 0 0 .488.488h.523a.488.488 0 0 1 .488.488v.523a.488.488 0 0 0 .488.488.488.488 0 0 0 .488-.488v-.523a.488.488 0 0 1 .488-.488h.524a.488.488 0 0 0 .488-.488.488.488 0 0 0-.488-.488h-.524a.488.488 0 0 1-.49-.488Z"
//               data-name="Path 100149"
//             />
//           </g>
//           <g data-name="Group 110753">
//             <path
//               fill="#ced3dd"
//               d="M164.224 100.544v-.523a.488.488 0 0 0-.488-.488.488.488 0 0 0-.488.488v.523a.487.487 0 0 1-.488.488h-.523a.488.488 0 0 0-.488.488.488.488 0 0 0 .488.488h.523a.488.488 0 0 1 .488.488v.523a.488.488 0 0 0 .488.488.488.488 0 0 0 .488-.488v-.523a.488.488 0 0 1 .488-.488h.523a.488.488 0 0 0 .488-.488.488.488 0 0 0-.488-.488h-.523a.488.488 0 0 1-.488-.488Z"
//               data-name="Path 100150"
//             />
//           </g>
//           <circle
//             cx={1.732}
//             cy={1.732}
//             r={1.732}
//             fill="#ced3dd"
//             data-name="Ellipse 129678"
//             transform="translate(32.051 101.095)"
//           />
//           <circle
//             cx={1.732}
//             cy={1.732}
//             r={1.732}
//             fill="#ced3dd"
//             data-name="Ellipse 129679"
//             transform="translate(167.862 51.878)"
//           />
//           <path
//             fill="#ced3dd"
//             d="M42.419 79.462a.945.945 0 1 1-.945-.945.945.945 0 0 1 .945.945Z"
//             data-name="Path 100151"
//           />
//           <path
//             fill="#ced3dd"
//             d="M21.718 66.629a1.255 1.255 0 1 1-1.255-1.255 1.256 1.256 0 0 1 1.255 1.255Z"
//             data-name="Path 100152"
//           />
//           <circle
//             cx={1.255}
//             cy={1.255}
//             r={1.255}
//             fill="#ced3dd"
//             data-name="Ellipse 129680"
//             transform="translate(144.948 89.165)"
//           />
//           <g
//             fill="none"
//             stroke="#ced3dd"
//             data-name="Ellipse 129681"
//             transform="translate(41.897 142.336)"
//           >
//             <circle cx={1.575} cy={1.575} r={1.575} stroke="none" />
//             <circle cx={1.575} cy={1.575} r={1.075} />
//           </g>
//           <g fill="none" data-name="Path 100153">
//             <path d="M13.303 154.972a2.01 2.01 0 1 1-2.01-2.01 2.01 2.01 0 0 1 2.01 2.01Z" />
//             <path
//               fill="#e4e8ee"
//               d="M11.293 153.962a1.01 1.01 0 0 0 0 2.02 1.01 1.01 0 0 0 0-2.02m0-1a2.01 2.01 0 1 1 0 4.02 2.01 2.01 0 0 1 0-4.02Z"
//             />
//           </g>
//           <g fill="none" data-name="Path 100154">
//             <path d="M172.237 78.102a2.01 2.01 0 1 1-2.01-2.01 2.009 2.009 0 0 1 2.01 2.01Z" />
//             <path
//               fill="#e4e8ee"
//               d="M170.227 79.11a1.01 1.01 0 0 0 0-2.018 1.01 1.01 0 0 0 0 2.019m0 1a2.01 2.01 0 1 1-.001-4.019 2.01 2.01 0 0 1 0 4.019Z"
//             />
//           </g>
//           <g fill="none" data-name="Path 100155">
//             <path d="M26.329 35.949a2.01 2.01 0 1 1 .488-2.8 2.009 2.009 0 0 1-.488 2.8Z" />
//             <path
//               fill="#e4e8ee"
//               d="M25.175 35.314a1.011 1.011 0 0 0-.003-2.02c-.208 0-.408.064-.58.185-.22.155-.367.386-.413.652a1.011 1.011 0 0 0 .996 1.183m0 1a2.01 2.01 0 1 1-.003-4.02 2.01 2.01 0 0 1 .003 4.02Z"
//             />
//           </g>
//           <g data-name="Group 110782">
//             <g data-name="Group 110781">
//               <g data-name="Group 110760">
//                 <path
//                   fill="#e4e8ee"
//                   d="M191.841 27.506v10.716h-10.614l-.128-.128-.128.128h-17.135l-.089-.089-.09.089h-9.22l-.345-.345-.346.345h-6.854l-.038-.038-.039.038h-6.33l-.025-.025-.026.025h-3.606V27.506a27.507 27.507 0 0 1 55.013 0Z"
//                   data-name="Path 100165"
//                 />
//                 <g data-name="Group 110759">
//                   <g data-name="Group 110758">
//                     <path
//                       fill="#e3f1fc"
//                       d="M136.747 186.864a27.159 27.159 0 0 1-27.076 25.389h-.179a27.509 27.509 0 0 0 27.255-25.389Z"
//                       data-name="Path 100166"
//                     />
//                     <path
//                       fill="#f5f7fa"
//                       d="M82.531 0a27.506 27.506 0 0 0-27.519 27.506v146.531h27.155v10.715a27.329 27.329 0 0 0 54.581 2.116c.051-.693.079-1.4.079-2.116V27.51A27.506 27.506 0 0 1 164.334.004Z"
//                       data-name="Path 100167"
//                     />
//                     <path
//                       fill="#e4e8ee"
//                       d="M90.221 204.199a27.423 27.423 0 0 1-8.056-19.45v-10.715H51.408l-.029.022-.021-.022h-6.334l-.036.036-.042-.036H0v10.715a27.5 27.5 0 0 0 27.505 27.505h81.987a27.434 27.434 0 0 1-19.271-8.055Z"
//                       data-name="Path 100168"
//                     />
//                   </g>
//                 </g>
//               </g>
//               <g data-name="Group 110780">
//                 <g fill="#e4e8ee" data-name="Group 110763">
//                   <g data-name="Group 110761">
//                     <path
//                       d="M62.166 65.996h26.656v2.813H62.166z"
//                       data-name="Rectangle 56349"
//                     />
//                     <path
//                       d="M62.166 75.178h17.911v2.813H62.166z"
//                       data-name="Rectangle 56350"
//                     />
//                     <path
//                       d="M62.166 84.36h23.808v2.813H62.166z"
//                       data-name="Rectangle 56351"
//                     />
//                     <path
//                       d="M62.166 93.542h30.599v2.813H62.166z"
//                       data-name="Rectangle 56352"
//                     />
//                     <path
//                       d="M62.166 121.089h26.656v2.813H62.166z"
//                       data-name="Rectangle 56353"
//                     />
//                     <path
//                       d="M62.166 130.271h9.366v2.813h-9.366z"
//                       data-name="Rectangle 56354"
//                     />
//                     <path
//                       d="M62.166 102.725h48.537v2.813H62.166z"
//                       data-name="Rectangle 56355"
//                     />
//                     <path
//                       d="M62.166 111.907h22.572v2.813H62.166z"
//                       data-name="Rectangle 56356"
//                     />
//                   </g>
//                   <g data-name="Group 110762">
//                     <path
//                       d="M119.992 65.996h9.37v2.813h-9.37z"
//                       data-name="Rectangle 56357"
//                     />
//                     <path
//                       d="M122.646 75.178h6.716v2.813h-6.716z"
//                       data-name="Rectangle 56358"
//                     />
//                     <path
//                       d="M119.992 84.36h9.37v2.813h-9.37z"
//                       data-name="Rectangle 56359"
//                     />
//                     <path
//                       d="M119.992 93.542h9.37v2.813h-9.37z"
//                       data-name="Rectangle 56360"
//                     />
//                     <path
//                       d="M122.646 121.089h6.716v2.813h-6.716z"
//                       data-name="Rectangle 56361"
//                     />
//                     <path
//                       d="M119.992 130.271h9.37v2.813h-9.37z"
//                       data-name="Rectangle 56362"
//                     />
//                     <path
//                       d="M122.646 102.725h6.716v2.813h-6.716z"
//                       data-name="Rectangle 56363"
//                     />
//                     <path
//                       d="M119.992 111.907h9.37v2.813h-9.37z"
//                       data-name="Rectangle 56364"
//                     />
//                     <path
//                       d="M62.166 148.115h26.656v2.813H62.166z"
//                       data-name="Rectangle 56365"
//                     />
//                     <path
//                       d="M62.166 157.298h9.366v4.66h-9.366z"
//                       data-name="Rectangle 56366"
//                     />
//                     <path
//                       d="M62.166 138.933h22.572v2.813H62.166z"
//                       data-name="Rectangle 56367"
//                     />
//                     <path
//                       d="M122.646 148.115h6.716v2.813h-6.716z"
//                       data-name="Rectangle 56368"
//                     />
//                     <path
//                       d="M119.992 157.298h9.37v4.66h-9.37z"
//                       data-name="Rectangle 56369"
//                     />
//                     <path
//                       d="M119.992 138.933h9.37v2.813h-9.37z"
//                       data-name="Rectangle 56370"
//                     />
//                   </g>
//                 </g>
//                 <g fill="#ced3dd" data-name="Group 110764">
//                   <path
//                     d="M78.932 40.655h35.598v3.365H78.932z"
//                     data-name="Rectangle 56371"
//                   />
//                   <path
//                     d="M85.616 26.487h22.23v3.365h-22.23z"
//                     data-name="Rectangle 56372"
//                   />
//                   <path
//                     d="M72.059 33.571h49.345v3.365H72.059z"
//                     data-name="Rectangle 56373"
//                   />
//                 </g>
//                 <g
//                   fill="none"
//                   stroke="#e4e8ee"
//                   strokeLinecap="round"
//                   strokeWidth={0.86}
//                   data-name="Group 110779"
//                 >
//                   <g data-name="Group 110765">
//                     <path
//                       d="m74.969 53.661 1.408 1.408"
//                       data-name="Line 1892"
//                     />
//                     <path
//                       d="m76.377 53.661-1.408 1.408"
//                       data-name="Line 1893"
//                     />
//                   </g>
//                   <g data-name="Group 110766">
//                     <path
//                       d="m116.923 53.661 1.408 1.408"
//                       data-name="Line 1894"
//                     />
//                     <path
//                       d="m118.331 53.661-1.408 1.408"
//                       data-name="Line 1895"
//                     />
//                   </g>
//                   <g data-name="Group 110767">
//                     <path
//                       d="m110.469 53.661 1.408 1.408"
//                       data-name="Line 1896"
//                     />
//                     <path
//                       d="m111.877 53.661-1.408 1.408"
//                       data-name="Line 1897"
//                     />
//                   </g>
//                   <g data-name="Group 110768">
//                     <path
//                       d="m107.242 53.661 1.408 1.408"
//                       data-name="Line 1898"
//                     />
//                     <path
//                       d="m108.65 53.661-1.408 1.408"
//                       data-name="Line 1899"
//                     />
//                   </g>
//                   <g data-name="Group 110769">
//                     <path
//                       d="m104.014 53.661 1.408 1.408"
//                       data-name="Line 1900"
//                     />
//                     <path
//                       d="m105.422 53.661-1.408 1.408"
//                       data-name="Line 1901"
//                     />
//                   </g>
//                   <g data-name="Group 110770">
//                     <path
//                       d="m100.787 53.661 1.408 1.408"
//                       data-name="Line 1902"
//                     />
//                     <path
//                       d="m102.195 53.661-1.408 1.408"
//                       data-name="Line 1903"
//                     />
//                   </g>
//                   <g data-name="Group 110771">
//                     <path d="m97.56 53.661 1.408 1.408" data-name="Line 1904" />
//                     <path
//                       d="m98.968 53.661-1.408 1.408"
//                       data-name="Line 1905"
//                     />
//                   </g>
//                   <g data-name="Group 110772">
//                     <path
//                       d="m113.696 53.661 1.408 1.408"
//                       data-name="Line 1906"
//                     />
//                     <path
//                       d="m115.104 53.661-1.408 1.408"
//                       data-name="Line 1907"
//                     />
//                   </g>
//                   <g data-name="Group 110773">
//                     <path
//                       d="m91.105 53.661 1.408 1.408"
//                       data-name="Line 1908"
//                     />
//                     <path
//                       d="m92.513 53.661-1.408 1.408"
//                       data-name="Line 1909"
//                     />
//                   </g>
//                   <g data-name="Group 110774">
//                     <path
//                       d="m87.878 53.661 1.408 1.408"
//                       data-name="Line 1910"
//                     />
//                     <path
//                       d="m89.286 53.661-1.408 1.408"
//                       data-name="Line 1911"
//                     />
//                   </g>
//                   <g data-name="Group 110775">
//                     <path
//                       d="m81.424 53.661 1.408 1.408"
//                       data-name="Line 1912"
//                     />
//                     <path
//                       d="m82.832 53.661-1.408 1.408"
//                       data-name="Line 1913"
//                     />
//                   </g>
//                   <g data-name="Group 110776">
//                     <path
//                       d="m78.196 53.661 1.408 1.408"
//                       data-name="Line 1914"
//                     />
//                     <path
//                       d="m79.604 53.661-1.408 1.408"
//                       data-name="Line 1915"
//                     />
//                   </g>
//                   <g data-name="Group 110777">
//                     <path
//                       d="m84.651 53.661 1.408 1.408"
//                       data-name="Line 1916"
//                     />
//                     <path
//                       d="m86.059 53.661-1.408 1.408"
//                       data-name="Line 1917"
//                     />
//                   </g>
//                   <g data-name="Group 110778">
//                     <path
//                       d="m94.333 53.661 1.408 1.408"
//                       data-name="Line 1918"
//                     />
//                     <path
//                       d="m95.741 53.661-1.408 1.408"
//                       data-name="Line 1919"
//                     />
//                   </g>
//                 </g>
//               </g>
//             </g>
//           </g>
//         </g>
//         <ellipse
//           cx={86.367}
//           cy={4.541}
//           fill="#e4e8ee"
//           data-name="Ellipse 129683"
//           opacity={0.47}
//           rx={86.367}
//           ry={4.541}
//           transform="translate(89.527 292.011)"
//         />
//       </g>
//       <path
//         fill="#4e5a6b"
//         d="M124.472 44.576h3.44a7.051 7.051 0 0 1 3.368.64 2.332 2.332 0 0 1 1.144 2.224 2.69 2.69 0 0 1-.5 1.656 2.213 2.213 0 0 1-1.424.84v.08a3.793 3.793 0 0 1 1.128.416 2.116 2.116 0 0 1 .808.84 2.994 2.994 0 0 1 .3 1.448 2.894 2.894 0 0 1-1.1 2.416 4.73 4.73 0 0 1-2.988.864h-4.176Zm2.048 4.656h1.664a2.636 2.636 0 0 0 1.672-.392 1.406 1.406 0 0 0 .456-1.128 1.192 1.192 0 0 0-.552-1.1 3.447 3.447 0 0 0-1.736-.336h-1.5Zm0 1.648v3.408h1.856a2.43 2.43 0 0 0 1.736-.488 1.721 1.721 0 0 0 .488-1.272 1.526 1.526 0 0 0-.5-1.2 2.776 2.776 0 0 0-1.82-.448Zm16 .768a4.647 4.647 0 0 1-1.12 3.336 4 4 0 0 1-3.04 1.176 4.2 4.2 0 0 1-2.112-.528 3.686 3.686 0 0 1-1.456-1.532 5.221 5.221 0 0 1-.528-2.448 4.609 4.609 0 0 1 1.112-3.32 4 4 0 0 1 3.032-1.16 4.279 4.279 0 0 1 2.128.52 3.644 3.644 0 0 1 1.456 1.52 5.172 5.172 0 0 1 .528 2.436Zm-6.192 0a3.9 3.9 0 0 0 .488 2.128 1.739 1.739 0 0 0 1.576.752 1.742 1.742 0 0 0 1.568-.752 3.852 3.852 0 0 0 .5-2.128 3.769 3.769 0 0 0-.5-2.112 1.772 1.772 0 0 0-1.584-.736 1.731 1.731 0 0 0-1.568.736 3.869 3.869 0 0 0-.48 2.112Zm15.888 0a4.647 4.647 0 0 1-1.116 3.336 4 4 0 0 1-3.044 1.176 4.2 4.2 0 0 1-2.112-.528 3.686 3.686 0 0 1-1.456-1.532 5.221 5.221 0 0 1-.528-2.448 4.609 4.609 0 0 1 1.112-3.32 4 4 0 0 1 3.028-1.164 4.279 4.279 0 0 1 2.128.52 3.644 3.644 0 0 1 1.456 1.52 5.172 5.172 0 0 1 .532 2.44Zm-6.192 0a3.9 3.9 0 0 0 .488 2.128 1.739 1.739 0 0 0 1.576.752 1.742 1.742 0 0 0 1.568-.752 3.852 3.852 0 0 0 .5-2.128 3.769 3.769 0 0 0-.5-2.112 1.772 1.772 0 0 0-1.584-.736 1.731 1.731 0 0 0-1.568.736 3.869 3.869 0 0 0-.48 2.112Zm10.144-7.808v5.776q0 .4-.032.872t-.064.888h.048q.208-.288.48-.656a7.108 7.108 0 0 1 .544-.656l2.56-2.736h2.288l-3.472 3.744L162.216 56h-2.352l-2.688-3.712-1.008.832V56h-2V43.84Zm8.288.144a1.346 1.346 0 0 1 .784.232.931.931 0 0 1 .336.824.953.953 0 0 1-.336.832 1.314 1.314 0 0 1-.784.24 1.3 1.3 0 0 1-.792-.24.964.964 0 0 1-.328-.832.941.941 0 0 1 .328-.824 1.336 1.336 0 0 1 .792-.232Zm1.008 3.344V56h-2.016v-8.672Zm7.088-.16a3.257 3.257 0 0 1 2.28.752 3.152 3.152 0 0 1 .824 2.432V56h-2.016v-5.248a2.341 2.341 0 0 0-.384-1.464 1.453 1.453 0 0 0-1.216-.488 1.76 1.76 0 0 0-1.664.768 4.4 4.4 0 0 0-.448 2.192V56h-2.016v-8.672h1.552l.288 1.136h.112a2.449 2.449 0 0 1 1.144-.984 3.878 3.878 0 0 1 1.544-.312Zm8.416 0a2.953 2.953 0 0 1 2.576 1.28h.08l.192-1.12h1.684v8.736a3.644 3.644 0 0 1-1.044 2.816 4.486 4.486 0 0 1-3.136.96 11.347 11.347 0 0 1-1.712-.12 6.52 6.52 0 0 1-1.488-.408v-1.664a8.115 8.115 0 0 0 1.576.5 8.524 8.524 0 0 0 1.752.176 1.983 1.983 0 0 0 1.5-.552 2.239 2.239 0 0 0 .532-1.612v-.224q0-.24.016-.56a4.675 4.675 0 0 1 .048-.512h-.064a2.749 2.749 0 0 1-1.1.984 3.332 3.332 0 0 1-1.46.312 2.936 2.936 0 0 1-2.48-1.184 5.356 5.356 0 0 1-.9-3.3 5.394 5.394 0 0 1 .9-3.312 2.976 2.976 0 0 1 2.528-1.196Zm.528 1.648q-1.888 0-1.888 2.9 0 2.848 1.92 2.848a1.951 1.951 0 0 0 1.56-.584 3.034 3.034 0 0 0 .504-1.98v-.3a3.744 3.744 0 0 0-.5-2.208 1.86 1.86 0 0 0-1.592-.676Zm17.312 4.064a2.9 2.9 0 0 1-1.108 2.4 4.78 4.78 0 0 1-3.052.88 7.251 7.251 0 0 1-3.2-.64V53.6a13.7 13.7 0 0 0 1.592.584 6.018 6.018 0 0 0 1.752.264 2.288 2.288 0 0 0 1.508-.408 1.322 1.322 0 0 0 .472-1.048 1.312 1.312 0 0 0-.608-1.128 10.173 10.173 0 0 0-1.776-.92 7.991 7.991 0 0 1-1.348-.712 3.491 3.491 0 0 1-1.056-1.072 3 3 0 0 1-.408-1.624 2.779 2.779 0 0 1 1.032-2.288 4.269 4.269 0 0 1 2.76-.832 7.35 7.35 0 0 1 1.7.192 8.911 8.911 0 0 1 1.592.544l-.652 1.648a10.837 10.837 0 0 0-1.368-.48 5.074 5.074 0 0 0-1.34-.176 1.9 1.9 0 0 0-1.26.368 1.218 1.218 0 0 0-.432.976 1.3 1.3 0 0 0 .24.792 2.191 2.191 0 0 0 .744.6q.5.272 1.3.624a9.531 9.531 0 0 1 1.576.84 3.164 3.164 0 0 1 .992 1.04 2.971 2.971 0 0 1 .348 1.496Zm9.536-5.552V56h-1.584l-.272-1.12h-.1a2.4 2.4 0 0 1-1.152.976 4.025 4.025 0 0 1-1.552.3 3.257 3.257 0 0 1-2.28-.752 3.129 3.129 0 0 1-.824-2.416v-5.66h2.02v5.264a2.305 2.305 0 0 0 .384 1.456 1.464 1.464 0 0 0 1.216.48 1.78 1.78 0 0 0 1.672-.768 4.331 4.331 0 0 0 .456-2.192v-4.24Zm12.384-.16a2.988 2.988 0 0 1 2.216.752 3.36 3.36 0 0 1 .744 2.432V56h-2.016v-5.264q0-1.936-1.472-1.936a1.658 1.658 0 0 0-1.5.688 3.679 3.679 0 0 0-.448 2V56h-2.02v-5.264q0-1.936-1.488-1.936a1.573 1.573 0 0 0-1.52.768 4.68 4.68 0 0 0-.416 2.192V56h-2.016v-8.672h1.552l.288 1.136h.112a2.4 2.4 0 0 1 1.088-.984 3.448 3.448 0 0 1 1.44-.312 3.761 3.761 0 0 1 1.64.32 2.176 2.176 0 0 1 1.016 1.024h.16a2.368 2.368 0 0 1 1.12-1.024 3.7 3.7 0 0 1 1.52-.32Zm15.3 0a2.988 2.988 0 0 1 2.216.752 3.36 3.36 0 0 1 .744 2.432V56h-2.02v-5.264q0-1.936-1.468-1.936a1.658 1.658 0 0 0-1.5.688 3.679 3.679 0 0 0-.448 2V56h-2.024v-5.264q0-1.936-1.488-1.936a1.573 1.573 0 0 0-1.52.768 4.68 4.68 0 0 0-.42 2.192V56h-2.012v-8.672h1.552l.288 1.136h.112a2.4 2.4 0 0 1 1.088-.984 3.448 3.448 0 0 1 1.44-.312 3.761 3.761 0 0 1 1.64.32 2.176 2.176 0 0 1 1.016 1.024h.16a2.368 2.368 0 0 1 1.116-1.024 3.7 3.7 0 0 1 1.524-.32Zm8.816 0a3.863 3.863 0 0 1 2.552.736 2.808 2.808 0 0 1 .872 2.272V56h-1.428l-.4-1.2h-.064a3.815 3.815 0 0 1-1.184 1.032 3.673 3.673 0 0 1-1.692.328 2.876 2.876 0 0 1-1.94-.66 2.528 2.528 0 0 1-.768-2.032 2.279 2.279 0 0 1 .984-2.016 5.757 5.757 0 0 1 2.984-.752l1.5-.048v-.432a1.51 1.51 0 0 0-.4-1.184 1.639 1.639 0 0 0-1.12-.352 4.26 4.26 0 0 0-1.256.184 9.585 9.585 0 0 0-1.192.456l-.64-1.408a6.638 6.638 0 0 1 1.464-.544 7 7 0 0 1 1.724-.204Zm1.42 4.732-1.056.032a3.252 3.252 0 0 0-1.84.456 1.329 1.329 0 0 0-.512 1.1 1.028 1.028 0 0 0 .36.888 1.573 1.573 0 0 0 .952.264 2.254 2.254 0 0 0 1.488-.5 1.831 1.831 0 0 0 .608-1.5Zm8.944-4.736q.208 0 .464.024t.416.056l-.176 1.876q-.16-.032-.392-.056a3.912 3.912 0 0 0-.392-.024 2.779 2.779 0 0 0-1.2.264 2.128 2.128 0 0 0-.9.808 2.564 2.564 0 0 0-.348 1.388V56h-2.016v-8.672h1.552l.288 1.5h.1a3.633 3.633 0 0 1 1.056-1.176 2.572 2.572 0 0 1 1.548-.484Zm1.056.16h2.192l1.728 4.9a7.924 7.924 0 0 1 .288.92 6.846 6.846 0 0 1 .16.9h.068a8.133 8.133 0 0 1 .192-.888q.128-.472.288-.936l1.664-4.9h2.176l-3.7 9.824a4.628 4.628 0 0 1-1.352 1.992 3.227 3.227 0 0 1-2.1.7 5.272 5.272 0 0 1-.7-.04q-.3-.04-.5-.088v-1.6q.176.032.424.064a4.064 4.064 0 0 0 .52.032 1.617 1.617 0 0 0 1.184-.44 2.911 2.911 0 0 0 .688-1.1l.256-.7Z"
//         data-name="Path 101165"
//       />
//       <path
//         fill="#98a0ac"
//         d="M32.587 374h-1.26v-8.89h-3.122V364h7.49v1.11h-3.108Zm5.572-10.64v3.122a7.435 7.435 0 0 1-.07 1.05h.084a2.313 2.313 0 0 1 .987-.868 3.125 3.125 0 0 1 1.351-.294 2.893 2.893 0 0 1 2.051.651 2.758 2.758 0 0 1 .693 2.093V374h-1.218v-4.8q0-1.806-1.68-1.806a1.924 1.924 0 0 0-1.729.707 3.654 3.654 0 0 0-.469 2.023V374h-1.232v-10.64Zm10.206 3a3.15 3.15 0 0 1 1.652.42 2.745 2.745 0 0 1 1.071 1.183 4.038 4.038 0 0 1 .371 1.785v.742h-5.138a2.832 2.832 0 0 0 .651 1.939 2.272 2.272 0 0 0 1.743.665 5.444 5.444 0 0 0 1.267-.133 7.145 7.145 0 0 0 1.141-.385v1.074a5.844 5.844 0 0 1-1.134.371 6.478 6.478 0 0 1-1.33.119 3.95 3.95 0 0 1-1.89-.434 3.041 3.041 0 0 1-1.269-1.288 4.455 4.455 0 0 1-.455-2.114 4.951 4.951 0 0 1 .413-2.114 3.139 3.139 0 0 1 1.162-1.358 3.179 3.179 0 0 1 1.745-.476Zm-.014 1.008a1.781 1.781 0 0 0-1.393.567 2.673 2.673 0 0 0-.609 1.575h3.822a2.63 2.63 0 0 0-.448-1.547 1.584 1.584 0 0 0-1.372-.599Zm13.314 4.564a1.877 1.877 0 0 1-.812 1.652 3.786 3.786 0 0 1-2.184.56 6.3 6.3 0 0 1-1.351-.126 4.131 4.131 0 0 1-1-.35v-1.12a6.721 6.721 0 0 0 1.085.413 4.53 4.53 0 0 0 1.295.189 2.376 2.376 0 0 0 1.358-.3.942.942 0 0 0 .42-.8.869.869 0 0 0-.154-.5 1.633 1.633 0 0 0-.553-.448 8.754 8.754 0 0 0-1.141-.5 10.8 10.8 0 0 1-1.246-.56 2.3 2.3 0 0 1-.8-.672 1.694 1.694 0 0 1-.28-1.008 1.665 1.665 0 0 1 .777-1.47 3.612 3.612 0 0 1 2.037-.518 5.584 5.584 0 0 1 1.281.14 6.617 6.617 0 0 1 1.113.364l-.42.98a8.285 8.285 0 0 0-.99-.358 4.06 4.06 0 0 0-1.064-.14 2.227 2.227 0 0 0-1.155.245.749.749 0 0 0-.4.665.783.783 0 0 0 .182.532 1.949 1.949 0 0 0 .609.42q.427.21 1.141.476a9 9 0 0 1 1.218.546 2.162 2.162 0 0 1 .77.679 1.767 1.767 0 0 1 .264 1.005Zm7.98-5.432v7.5h-1.008l-.182-.994h-.056a2.138 2.138 0 0 1-1.008.861 3.479 3.479 0 0 1-1.372.273 2.867 2.867 0 0 1-2.044-.651 2.755 2.755 0 0 1-.686-2.079v-4.91h1.246v4.83q0 1.792 1.666 1.792a1.954 1.954 0 0 0 1.729-.7 3.535 3.535 0 0 0 .483-2.016V366.5Zm10.5-.14a2.521 2.521 0 0 1 1.9.658 2.958 2.958 0 0 1 .63 2.1V374h-1.218v-4.83q0-1.778-1.526-1.778a1.82 1.82 0 0 0-1.561.63 3.039 3.039 0 0 0-.469 1.834V374h-1.218v-4.83q0-1.778-1.54-1.778a1.7 1.7 0 0 0-1.568.7 3.851 3.851 0 0 0-.434 2.016V374h-1.232v-7.5h.994l.182 1.022h.07a2.189 2.189 0 0 1 .945-.875 2.879 2.879 0 0 1 1.267-.287 2.219 2.219 0 0 1 2.3 1.26h.07a2.336 2.336 0 0 1 1.022-.952 3.171 3.171 0 0 1 1.386-.312Zm12.978 0a2.521 2.521 0 0 1 1.9.658 2.958 2.958 0 0 1 .63 2.1V374h-1.218v-4.83q0-1.778-1.526-1.778a1.82 1.82 0 0 0-1.561.63 3.039 3.039 0 0 0-.469 1.834V374h-1.218v-4.83q0-1.778-1.54-1.778a1.7 1.7 0 0 0-1.568.7 3.851 3.851 0 0 0-.434 2.016V374h-1.232v-7.5h.994l.182 1.022h.07a2.189 2.189 0 0 1 .945-.875 2.879 2.879 0 0 1 1.267-.287 2.219 2.219 0 0 1 2.3 1.26h.07a2.336 2.336 0 0 1 1.022-.952 3.171 3.171 0 0 1 1.386-.312Zm7.588.014a2.931 2.931 0 0 1 2.03.6 2.485 2.485 0 0 1 .659 1.916V374h-.9l-.238-1.064h-.056a3.431 3.431 0 0 1-1.036.91 3.149 3.149 0 0 1-1.481.294A2.622 2.622 0 0 1 98 373.6a2.033 2.033 0 0 1-.672-1.687 1.977 1.977 0 0 1 .882-1.729 5.116 5.116 0 0 1 2.716-.665l1.274-.042v-.447a1.7 1.7 0 0 0-.406-1.3 1.661 1.661 0 0 0-1.148-.364 3.561 3.561 0 0 0-1.12.175 8.022 8.022 0 0 0-.994.4l-.378-.924a5.639 5.639 0 0 1 1.162-.455 5.146 5.146 0 0 1 1.395-.192Zm1.47 3.962-1.106.042a3.73 3.73 0 0 0-1.939.448 1.288 1.288 0 0 0-.536 1.102 1.088 1.088 0 0 0 .385.924 1.581 1.581 0 0 0 .987.294 2.394 2.394 0 0 0 1.575-.525 1.975 1.975 0 0 0 .634-1.621Zm6.93-3.976q.21 0 .448.021a3.582 3.582 0 0 1 .434.063l-.154 1.134a4.048 4.048 0 0 0-.406-.07 3.3 3.3 0 0 0-.406-.028 2 2 0 0 0-1.078.315 2.268 2.268 0 0 0-.805.882 2.781 2.781 0 0 0-.301 1.323v4h-1.232v-7.5h1.008l.14 1.372h.056a3.549 3.549 0 0 1 .931-1.072 2.171 2.171 0 0 1 1.365-.444Zm.994.14h1.316l1.624 4.27q.21.574.378 1.078a7.053 7.053 0 0 1 .252.966h.056q.084-.35.266-.917t.378-1.141l1.525-4.256h1.33l-3.23 8.536a4.874 4.874 0 0 1-1.025 1.694 2.279 2.279 0 0 1-1.708.63 4.329 4.329 0 0 1-.588-.035q-.252-.035-.434-.077v-.98q.154.028.371.056a3.556 3.556 0 0 0 .455.028 1.462 1.462 0 0 0 1.036-.364 2.594 2.594 0 0 0 .63-.966l.392-.994Zm17.864 7.49-1.288-4.228q-.182-.574-.322-1.12t-.2-.868h-.056q-.056.322-.182.868t-.321 1.13l-1.341 4.214h-1.4l-2.058-7.5h1.274l1.036 4q.154.6.294 1.218t.2 1.022h.056q.042-.238.126-.588t.182-.735q.1-.385.2-.693l1.33-4.228h1.344l1.288 4.228q.14.49.294 1.05a7.92 7.92 0 0 1 .21.952h.056a9.136 9.136 0 0 1 .189-.966q.147-.616.315-1.26l1.05-4h1.26l-2.086 7.5Zm5.39-10.3a.735.735 0 0 1 .5.189.749.749 0 0 1 .217.595.749.749 0 0 1-.217.6.735.735 0 0 1-.5.189.746.746 0 0 1-.518-.189.763.763 0 0 1-.21-.6.763.763 0 0 1 .21-.595.746.746 0 0 1 .518-.197Zm.6 2.814V374h-1.232v-7.5Zm3.5 7.5h-1.232V363.36h1.232Zm3.5 0h-1.232V363.36h1.232Zm7.028-10.64v2.59q0 .476-.021.889t-.049.651h.07a2.615 2.615 0 0 1 .882-.8 2.869 2.869 0 0 1 1.442-.322 2.832 2.832 0 0 1 2.247.973 4.317 4.317 0 0 1 .847 2.9 4.322 4.322 0 0 1-.852 2.915 2.828 2.828 0 0 1-2.24.98 2.869 2.869 0 0 1-1.442-.322 2.753 2.753 0 0 1-.882-.77h-.1l-.25.952h-.882v-10.64Zm2.113 4.028a1.844 1.844 0 0 0-1.659.686 3.919 3.919 0 0 0-.455 2.128v.056a4.059 4.059 0 0 0 .455 2.121 1.824 1.824 0 0 0 1.687.735 1.689 1.689 0 0 0 1.505-.742 3.846 3.846 0 0 0 .5-2.142q0-2.842-2.033-2.842Zm8.05-1.036a3.15 3.15 0 0 1 1.652.42 2.745 2.745 0 0 1 1.071 1.183 4.038 4.038 0 0 1 .371 1.785v.742h-5.138a2.832 2.832 0 0 0 .651 1.939 2.272 2.272 0 0 0 1.743.665 5.444 5.444 0 0 0 1.267-.133 7.146 7.146 0 0 0 1.141-.385v1.078a5.844 5.844 0 0 1-1.134.371 6.478 6.478 0 0 1-1.33.119 3.95 3.95 0 0 1-1.89-.434 3.041 3.041 0 0 1-1.264-1.288 4.455 4.455 0 0 1-.455-2.118 4.951 4.951 0 0 1 .413-2.114 3.139 3.139 0 0 1 1.162-1.354 3.179 3.179 0 0 1 1.743-.476Zm-.014 1.008a1.781 1.781 0 0 0-1.393.567 2.673 2.673 0 0 0-.609 1.575h3.822a2.631 2.631 0 0 0-.448-1.547 1.584 1.584 0 0 0-1.369-.595Zm11.27-.994a2.931 2.931 0 0 1 2.03.6 2.485 2.485 0 0 1 .664 1.92V374h-.9l-.238-1.064h-.056a3.431 3.431 0 0 1-1.036.91 3.149 3.149 0 0 1-1.483.294 2.622 2.622 0 0 1-1.694-.54 2.033 2.033 0 0 1-.672-1.687 1.978 1.978 0 0 1 .879-1.728 5.116 5.116 0 0 1 2.716-.665l1.274-.042v-.448a1.7 1.7 0 0 0-.406-1.3 1.661 1.661 0 0 0-1.148-.364 3.561 3.561 0 0 0-1.12.175 8.022 8.022 0 0 0-.994.4l-.378-.924a5.639 5.639 0 0 1 1.162-.455 5.147 5.147 0 0 1 1.403-.192Zm1.47 3.962-1.106.042a3.73 3.73 0 0 0-1.939.448 1.288 1.288 0 0 0-.531 1.106 1.088 1.088 0 0 0 .385.924 1.581 1.581 0 0 0 .987.294 2.394 2.394 0 0 0 1.575-.525 1.975 1.975 0 0 0 .632-1.621Zm6.093 3.808a2.811 2.811 0 0 1-2.24-.973 4.342 4.342 0 0 1-.84-2.905 4.375 4.375 0 0 1 .847-2.919 2.814 2.814 0 0 1 2.247-.987 2.8 2.8 0 0 1 1.421.322 3.022 3.022 0 0 1 .9.784h.084q-.028-.182-.056-.539t-.028-.567v-3h1.232V374h-.994l-.182-1.008h-.056a2.906 2.906 0 0 1-.9.812 2.771 2.771 0 0 1-1.435.336Zm.2-1.022a1.952 1.952 0 0 0 1.673-.651 3.293 3.293 0 0 0 .479-1.967v-.224a4.119 4.119 0 0 0-.462-2.149 1.844 1.844 0 0 0-1.708-.749 1.645 1.645 0 0 0-1.491.791 3.952 3.952 0 0 0-.5 2.121 3.726 3.726 0 0 0 .5 2.086 1.689 1.689 0 0 0 1.505.742Zm8.298 1.022a2.811 2.811 0 0 1-2.24-.973 4.342 4.342 0 0 1-.84-2.905 4.375 4.375 0 0 1 .847-2.919 2.814 2.814 0 0 1 2.247-.987 2.8 2.8 0 0 1 1.419.322 3.022 3.022 0 0 1 .9.784h.084q-.028-.182-.056-.539t-.028-.567v-3h1.232V374h-.994l-.182-1.008h-.056a2.906 2.906 0 0 1-.9.812 2.771 2.771 0 0 1-1.433.336Zm.2-1.022a1.952 1.952 0 0 0 1.673-.651 3.293 3.293 0 0 0 .479-1.967v-.224a4.119 4.119 0 0 0-.462-2.149 1.844 1.844 0 0 0-1.708-.749 1.645 1.645 0 0 0-1.491.791 3.952 3.952 0 0 0-.5 2.121 3.726 3.726 0 0 0 .5 2.086 1.689 1.689 0 0 0 1.505.742Zm8.533-6.762a3.15 3.15 0 0 1 1.652.42 2.745 2.745 0 0 1 1.074 1.183 4.038 4.038 0 0 1 .374 1.785v.742h-5.141a2.832 2.832 0 0 0 .651 1.939 2.272 2.272 0 0 0 1.743.665 5.444 5.444 0 0 0 1.267-.133 7.145 7.145 0 0 0 1.141-.385v1.078a5.844 5.844 0 0 1-1.134.371 6.478 6.478 0 0 1-1.327.119 3.95 3.95 0 0 1-1.89-.434 3.041 3.041 0 0 1-1.27-1.288 4.455 4.455 0 0 1-.455-2.118 4.951 4.951 0 0 1 .415-2.11 3.139 3.139 0 0 1 1.16-1.358 3.179 3.179 0 0 1 1.74-.476Zm-.011 1.008a1.781 1.781 0 0 0-1.389.567 2.673 2.673 0 0 0-.609 1.575h3.818a2.631 2.631 0 0 0-.448-1.547 1.584 1.584 0 0 0-1.372-.595Zm7.56 6.776a2.811 2.811 0 0 1-2.24-.973 4.342 4.342 0 0 1-.84-2.905 4.375 4.375 0 0 1 .847-2.919 2.814 2.814 0 0 1 2.247-.987 2.8 2.8 0 0 1 1.421.322 3.022 3.022 0 0 1 .9.784h.084q-.028-.182-.056-.539t-.028-.567v-3h1.232V374h-.994l-.182-1.008h-.056a2.906 2.906 0 0 1-.9.812 2.771 2.771 0 0 1-1.435.336Zm.2-1.022a1.952 1.952 0 0 0 1.673-.651 3.293 3.293 0 0 0 .478-1.967v-.224a4.119 4.119 0 0 0-.462-2.149 1.844 1.844 0 0 0-1.708-.749 1.645 1.645 0 0 0-1.491.791 3.952 3.952 0 0 0-.5 2.121 3.726 3.726 0 0 0 .5 2.086 1.689 1.689 0 0 0 1.506.742Zm15.69-2.884a4.091 4.091 0 0 1-.945 2.884 3.31 3.31 0 0 1-2.555 1.022 3.439 3.439 0 0 1-1.771-.455 3.169 3.169 0 0 1-1.225-1.33 4.61 4.61 0 0 1-.443-2.121 4.077 4.077 0 0 1 .931-2.87 3.306 3.306 0 0 1 2.555-1.008 3.5 3.5 0 0 1 1.792.455 3.128 3.128 0 0 1 1.222 1.316 4.583 4.583 0 0 1 .439 2.107Zm-5.67 0a3.715 3.715 0 0 0 .525 2.107 1.874 1.874 0 0 0 1.673.777 1.877 1.877 0 0 0 1.666-.777 3.677 3.677 0 0 0 .532-2.107 3.575 3.575 0 0 0-.532-2.086 1.911 1.911 0 0 0-1.68-.756 1.875 1.875 0 0 0-1.666.756 3.648 3.648 0 0 0-.518 2.086Zm11.116-3.878a2.826 2.826 0 0 1 2.03.658 2.8 2.8 0 0 1 .686 2.1V374h-1.218v-4.8q0-1.806-1.68-1.806a1.935 1.935 0 0 0-1.722.7 3.575 3.575 0 0 0-.476 2.016V374h-1.232v-7.5h.994l.182 1.022h.07a2.22 2.22 0 0 1 1.008-.875 3.3 3.3 0 0 1 1.358-.291Zm7.938 7.784a3.756 3.756 0 0 1-1.778-.406 2.855 2.855 0 0 1-1.211-1.26 4.747 4.747 0 0 1-.441-2.184 4.85 4.85 0 0 1 .455-2.254 2.878 2.878 0 0 1 1.252-1.274 3.926 3.926 0 0 1 1.806-.406 5.083 5.083 0 0 1 1.1.119 3.839 3.839 0 0 1 .875.287l-.381 1.022a7.285 7.285 0 0 0-.784-.238 3.472 3.472 0 0 0-.84-.112q-2.212 0-2.212 2.842a3.429 3.429 0 0 0 .539 2.079 1.875 1.875 0 0 0 1.6.721 4.22 4.22 0 0 0 1.078-.126 5.249 5.249 0 0 0 .868-.308v1.092a3.522 3.522 0 0 1-.833.3 4.958 4.958 0 0 1-1.093.106Zm6.5-7.784a3.15 3.15 0 0 1 1.652.42 2.745 2.745 0 0 1 1.071 1.183 4.038 4.038 0 0 1 .371 1.785v.742h-5.142a2.832 2.832 0 0 0 .651 1.939 2.272 2.272 0 0 0 1.743.665 5.444 5.444 0 0 0 1.267-.133 7.146 7.146 0 0 0 1.141-.385v1.078a5.844 5.844 0 0 1-1.134.371 6.478 6.478 0 0 1-1.33.119 3.95 3.95 0 0 1-1.89-.434 3.041 3.041 0 0 1-1.267-1.288 4.455 4.455 0 0 1-.456-2.118 4.951 4.951 0 0 1 .413-2.114 3.139 3.139 0 0 1 1.162-1.358 3.179 3.179 0 0 1 1.744-.472Zm-.014 1.008a1.781 1.781 0 0 0-1.393.567 2.673 2.673 0 0 0-.616 1.575h3.822a2.631 2.631 0 0 0-.448-1.547 1.584 1.584 0 0 0-1.369-.595Zm10.93 5.768a4.057 4.057 0 0 0 .574-.042 2.242 2.242 0 0 0 .476-.112v.938a2.1 2.1 0 0 1-.56.161 4.105 4.105 0 0 1-.7.063 2.842 2.842 0 0 1-1.085-.2 1.678 1.678 0 0 1-.805-.707 2.718 2.718 0 0 1-.308-1.414v-4.371h-1.064v-.588l1.078-.49.49-1.6h.728v1.73h2.17v.952h-2.17v4.34a1.383 1.383 0 0 0 .329 1.008 1.146 1.146 0 0 0 .847.332Zm3.668-9.772v3.122a7.434 7.434 0 0 1-.07 1.05h.084a2.313 2.313 0 0 1 .987-.868 3.125 3.125 0 0 1 1.351-.294 2.893 2.893 0 0 1 2.051.651 2.758 2.758 0 0 1 .69 2.093V374h-1.215v-4.8q0-1.806-1.68-1.806a1.924 1.924 0 0 0-1.729.707 3.654 3.654 0 0 0-.469 2.023V374h-1.232v-10.64Zm10.206 3a3.15 3.15 0 0 1 1.652.42 2.745 2.745 0 0 1 1.071 1.183 4.038 4.038 0 0 1 .371 1.785v.742h-5.138a2.832 2.832 0 0 0 .651 1.939 2.272 2.272 0 0 0 1.743.665 5.444 5.444 0 0 0 1.267-.133 7.145 7.145 0 0 0 1.141-.385v1.074a5.844 5.844 0 0 1-1.134.371 6.477 6.477 0 0 1-1.33.119 3.95 3.95 0 0 1-1.89-.434 3.041 3.041 0 0 1-1.267-1.288 4.455 4.455 0 0 1-.45-2.118 4.951 4.951 0 0 1 .413-2.114 3.139 3.139 0 0 1 1.157-1.354 3.179 3.179 0 0 1 1.743-.476Zm-.013 1.004a1.781 1.781 0 0 0-1.393.567 2.673 2.673 0 0 0-.607 1.575h3.822a2.631 2.631 0 0 0-.448-1.547 1.584 1.584 0 0 0-1.374-.595Zm11.27-.994a2.931 2.931 0 0 1 2.03.6 2.485 2.485 0 0 1 .658 1.918V374h-.9l-.238-1.064h-.056a3.431 3.431 0 0 1-1.036.91 3.149 3.149 0 0 1-1.481.294 2.622 2.622 0 0 1-1.694-.54 2.033 2.033 0 0 1-.672-1.687 1.977 1.977 0 0 1 .882-1.729 5.116 5.116 0 0 1 2.716-.665l1.274-.042v-.447a1.7 1.7 0 0 0-.406-1.3 1.661 1.661 0 0 0-1.147-.366 3.561 3.561 0 0 0-1.12.175 8.022 8.022 0 0 0-.994.4l-.378-.924a5.639 5.639 0 0 1 1.162-.455 5.146 5.146 0 0 1 1.399-.19Zm1.47 3.962-1.106.042a3.73 3.73 0 0 0-1.939.448 1.288 1.288 0 0 0-.539 1.106 1.088 1.088 0 0 0 .385.924 1.581 1.581 0 0 0 .987.294 2.394 2.394 0 0 0 1.572-.525 1.975 1.975 0 0 0 .639-1.621Zm11.66-3.976a2.521 2.521 0 0 1 1.9.658 2.958 2.958 0 0 1 .63 2.1V374h-1.213v-4.83q0-1.778-1.526-1.778a1.82 1.82 0 0 0-1.561.63 3.039 3.039 0 0 0-.469 1.834V374h-1.218v-4.83q0-1.778-1.54-1.778a1.7 1.7 0 0 0-1.568.7 3.851 3.851 0 0 0-.435 2.016V374h-1.231v-7.5h.994l.182 1.022h.07a2.189 2.189 0 0 1 .945-.875 2.879 2.879 0 0 1 1.267-.287 2.219 2.219 0 0 1 2.3 1.26h.07a2.336 2.336 0 0 1 1.022-.952 3.171 3.171 0 0 1 1.381-.312Zm7.644 0a3.15 3.15 0 0 1 1.652.42 2.745 2.745 0 0 1 1.071 1.183 4.038 4.038 0 0 1 .371 1.785v.742H292.3a2.832 2.832 0 0 0 .651 1.939 2.272 2.272 0 0 0 1.749.665 5.444 5.444 0 0 0 1.267-.133 7.145 7.145 0 0 0 1.141-.385v1.078a5.844 5.844 0 0 1-1.134.371 6.477 6.477 0 0 1-1.33.119 3.95 3.95 0 0 1-1.89-.434 3.041 3.041 0 0 1-1.267-1.288 4.455 4.455 0 0 1-.46-2.118 4.951 4.951 0 0 1 .413-2.11 3.139 3.139 0 0 1 1.16-1.358 3.179 3.179 0 0 1 1.745-.476Zm-.014 1.008a1.781 1.781 0 0 0-1.393.567 2.673 2.673 0 0 0-.609 1.575h3.822a2.631 2.631 0 0 0-.448-1.547 1.584 1.584 0 0 0-1.371-.595Zm8.512-1.008a2.826 2.826 0 0 1 2.03.658 2.8 2.8 0 0 1 .686 2.1V374h-1.218v-4.8q0-1.806-1.68-1.806a1.935 1.935 0 0 0-1.722.7 3.575 3.575 0 0 0-.476 2.016V374h-1.232v-7.5h.994l.182 1.022h.07a2.22 2.22 0 0 1 1.008-.875 3.3 3.3 0 0 1 1.359-.291Zm5.558-2.674a.735.735 0 0 1 .5.189.749.749 0 0 1 .217.595.749.749 0 0 1-.217.6.735.735 0 0 1-.5.189.746.746 0 0 1-.518-.189.763.763 0 0 1-.21-.6.763.763 0 0 1 .21-.595.746.746 0 0 1 .518-.189Zm.6 2.818v7.5h-1.232v-7.5Zm4.774 6.636a4.057 4.057 0 0 0 .574-.042 2.242 2.242 0 0 0 .476-.112v.938a2.1 2.1 0 0 1-.56.161 4.105 4.105 0 0 1-.7.063 2.842 2.842 0 0 1-1.085-.2 1.678 1.678 0 0 1-.805-.707 2.718 2.718 0 0 1-.308-1.414v-4.375h-1.064v-.588l1.078-.49.49-1.6h.728v1.73h2.17v.952H312.6v4.34a1.383 1.383 0 0 0 .33 1.008 1.146 1.146 0 0 0 .847.332Zm3.066-9.45a.735.735 0 0 1 .5.189.749.749 0 0 1 .217.595.749.749 0 0 1-.217.6.735.735 0 0 1-.5.189.746.746 0 0 1-.518-.189.763.763 0 0 1-.21-.6.763.763 0 0 1 .21-.595.746.746 0 0 1 .521-.193Zm.6 2.814v7.5h-1.232v-7.5Zm5.166-.14a3.15 3.15 0 0 1 1.652.42 2.745 2.745 0 0 1 1.071 1.183 4.038 4.038 0 0 1 .371 1.785v.742h-5.138a2.832 2.832 0 0 0 .651 1.939 2.272 2.272 0 0 0 1.743.665 5.444 5.444 0 0 0 1.267-.133 7.145 7.145 0 0 0 1.141-.385v1.074a5.844 5.844 0 0 1-1.134.371 6.478 6.478 0 0 1-1.33.119 3.95 3.95 0 0 1-1.89-.434 3.041 3.041 0 0 1-1.267-1.288 4.455 4.455 0 0 1-.455-2.114 4.951 4.951 0 0 1 .413-2.114 3.139 3.139 0 0 1 1.162-1.358 3.179 3.179 0 0 1 1.748-.476Zm-.006 1.004a1.781 1.781 0 0 0-1.393.567 2.673 2.673 0 0 0-.609 1.575h3.822a2.63 2.63 0 0 0-.448-1.547 1.584 1.584 0 0 0-1.372-.595Zm9.786 4.564a1.877 1.877 0 0 1-.812 1.652 3.786 3.786 0 0 1-2.184.56 6.3 6.3 0 0 1-1.351-.126 4.131 4.131 0 0 1-1-.35v-1.12a6.721 6.721 0 0 0 1.085.413 4.53 4.53 0 0 0 1.295.189 2.376 2.376 0 0 0 1.358-.3.942.942 0 0 0 .42-.8.869.869 0 0 0-.154-.5 1.633 1.633 0 0 0-.553-.448 8.754 8.754 0 0 0-1.141-.5 10.8 10.8 0 0 1-1.246-.56 2.3 2.3 0 0 1-.8-.672 1.694 1.694 0 0 1-.28-1.008 1.665 1.665 0 0 1 .777-1.47 3.612 3.612 0 0 1 2.037-.518 5.584 5.584 0 0 1 1.281.14 6.617 6.617 0 0 1 1.113.364l-.42.98a8.285 8.285 0 0 0-.994-.336 4.06 4.06 0 0 0-1.064-.14 2.227 2.227 0 0 0-1.155.245.749.749 0 0 0-.4.665.783.783 0 0 0 .182.532 1.949 1.949 0 0 0 .609.42q.427.21 1.141.476a9 9 0 0 1 1.218.546 2.162 2.162 0 0 1 .77.679 1.767 1.767 0 0 1 .265.987Zm10.122 0a1.877 1.877 0 0 1-.812 1.652 3.786 3.786 0 0 1-2.184.56 6.3 6.3 0 0 1-1.351-.126 4.131 4.131 0 0 1-1-.35v-1.12a6.721 6.721 0 0 0 1.085.413 4.53 4.53 0 0 0 1.295.189 2.376 2.376 0 0 0 1.358-.3.942.942 0 0 0 .42-.8.869.869 0 0 0-.154-.5 1.633 1.633 0 0 0-.553-.448 8.754 8.754 0 0 0-1.141-.5 10.8 10.8 0 0 1-1.246-.56 2.3 2.3 0 0 1-.8-.672 1.694 1.694 0 0 1-.28-1.008 1.665 1.665 0 0 1 .777-1.47 3.612 3.612 0 0 1 2.037-.518 5.584 5.584 0 0 1 1.281.14 6.617 6.617 0 0 1 1.113.364l-.42.98a8.285 8.285 0 0 0-.994-.336 4.06 4.06 0 0 0-1.064-.14 2.227 2.227 0 0 0-1.155.245.749.749 0 0 0-.4.665.783.783 0 0 0 .182.532 1.949 1.949 0 0 0 .609.42q.427.21 1.141.476a9 9 0 0 1 1.218.546 2.162 2.162 0 0 1 .77.679 1.767 1.767 0 0 1 .265.987Zm2.937 2.072h-1.232v-10.64h1.232Zm8.792-3.766a4.091 4.091 0 0 1-.945 2.884 3.31 3.31 0 0 1-2.555 1.022 3.439 3.439 0 0 1-1.771-.455 3.169 3.169 0 0 1-1.225-1.33 4.61 4.61 0 0 1-.448-2.121 4.077 4.077 0 0 1 .931-2.87 3.306 3.306 0 0 1 2.555-1.008 3.5 3.5 0 0 1 1.792.455 3.128 3.128 0 0 1 1.229 1.316 4.583 4.583 0 0 1 .437 2.107Zm-5.67 0a3.715 3.715 0 0 0 .525 2.107 1.874 1.874 0 0 0 1.673.777 1.877 1.877 0 0 0 1.666-.777 3.677 3.677 0 0 0 .532-2.107 3.575 3.575 0 0 0-.532-2.086 1.912 1.912 0 0 0-1.68-.756 1.875 1.875 0 0 0-1.666.756 3.649 3.649 0 0 0-.518 2.086Zm10.01 2.9a4.057 4.057 0 0 0 .574-.042 2.242 2.242 0 0 0 .476-.112v.938a2.1 2.1 0 0 1-.56.161 4.105 4.105 0 0 1-.7.063 2.842 2.842 0 0 1-1.085-.2 1.679 1.679 0 0 1-.805-.707 2.718 2.718 0 0 1-.308-1.414v-4.373H355.1v-.588l1.078-.49.49-1.6h.728v1.73h2.17v.952H357.4v4.34a1.383 1.383 0 0 0 .33 1.008 1.146 1.146 0 0 0 .847.332Zm-196.371 9.548a.735.735 0 0 1 .5.189.749.749 0 0 1 .217.595.749.749 0 0 1-.217.6.735.735 0 0 1-.5.189.746.746 0 0 1-.518-.189.763.763 0 0 1-.21-.6.763.763 0 0 1 .21-.595.746.746 0 0 1 .518-.189Zm.6 2.814V393h-1.232v-7.5Zm7.154 5.432a1.877 1.877 0 0 1-.812 1.652 3.786 3.786 0 0 1-2.184.56 6.3 6.3 0 0 1-1.351-.126 4.131 4.131 0 0 1-1-.35v-1.12a6.722 6.722 0 0 0 1.085.413 4.53 4.53 0 0 0 1.3.189 2.376 2.376 0 0 0 1.358-.3.942.942 0 0 0 .42-.8.869.869 0 0 0-.154-.5 1.633 1.633 0 0 0-.553-.448 8.754 8.754 0 0 0-1.141-.5 10.8 10.8 0 0 1-1.246-.56 2.3 2.3 0 0 1-.8-.672 1.694 1.694 0 0 1-.28-1.008 1.665 1.665 0 0 1 .777-1.47 3.612 3.612 0 0 1 2.037-.518 5.584 5.584 0 0 1 1.281.14 6.617 6.617 0 0 1 1.113.364l-.42.98a8.285 8.285 0 0 0-.994-.336 4.06 4.06 0 0 0-1.064-.14 2.227 2.227 0 0 0-1.155.245.749.749 0 0 0-.4.665.783.783 0 0 0 .182.532 1.949 1.949 0 0 0 .609.42q.427.21 1.141.476a9 9 0 0 1 1.218.546 2.162 2.162 0 0 1 .77.679 1.767 1.767 0 0 1 .265.987Zm10.122 0a1.877 1.877 0 0 1-.812 1.652 3.786 3.786 0 0 1-2.184.56 6.3 6.3 0 0 1-1.351-.126 4.131 4.131 0 0 1-1-.35v-1.12a6.722 6.722 0 0 0 1.085.413 4.53 4.53 0 0 0 1.3.189 2.376 2.376 0 0 0 1.358-.3.942.942 0 0 0 .42-.8.869.869 0 0 0-.154-.5 1.633 1.633 0 0 0-.553-.448 8.754 8.754 0 0 0-1.141-.5 10.8 10.8 0 0 1-1.246-.56 2.3 2.3 0 0 1-.8-.672 1.694 1.694 0 0 1-.28-1.008 1.665 1.665 0 0 1 .777-1.47 3.612 3.612 0 0 1 2.037-.518 5.584 5.584 0 0 1 1.281.14 6.617 6.617 0 0 1 1.113.364l-.42.98a8.285 8.285 0 0 0-.994-.336 4.06 4.06 0 0 0-1.064-.14 2.227 2.227 0 0 0-1.155.245.749.749 0 0 0-.4.665.783.783 0 0 0 .182.532 1.949 1.949 0 0 0 .609.42q.427.21 1.141.476a9 9 0 0 1 1.218.546 2.162 2.162 0 0 1 .77.679 1.767 1.767 0 0 1 .265.987Zm4.606-5.572a3.15 3.15 0 0 1 1.652.42 2.745 2.745 0 0 1 1.071 1.183 4.038 4.038 0 0 1 .371 1.785v.742h-5.138a2.832 2.832 0 0 0 .651 1.939 2.272 2.272 0 0 0 1.743.665 5.444 5.444 0 0 0 1.267-.133 7.145 7.145 0 0 0 1.141-.385v1.078a5.844 5.844 0 0 1-1.134.371 6.478 6.478 0 0 1-1.33.119 3.95 3.95 0 0 1-1.89-.434 3.041 3.041 0 0 1-1.267-1.288 4.455 4.455 0 0 1-.455-2.114 4.951 4.951 0 0 1 .413-2.114 3.139 3.139 0 0 1 1.162-1.358 3.179 3.179 0 0 1 1.745-.476Zm-.014 1.008a1.781 1.781 0 0 0-1.393.567 2.673 2.673 0 0 0-.609 1.575h3.828a2.631 2.631 0 0 0-.448-1.547 1.584 1.584 0 0 0-1.376-.595Zm6.134 6.636h-1.232v-10.64h1.232Zm5.166-7.644a3.15 3.15 0 0 1 1.652.42 2.745 2.745 0 0 1 1.074 1.183 4.038 4.038 0 0 1 .371 1.785v.742h-5.141a2.832 2.832 0 0 0 .651 1.939 2.272 2.272 0 0 0 1.743.665 5.444 5.444 0 0 0 1.267-.133 7.145 7.145 0 0 0 1.141-.385v1.078a5.844 5.844 0 0 1-1.134.371 6.478 6.478 0 0 1-1.33.119 3.95 3.95 0 0 1-1.89-.434 3.041 3.041 0 0 1-1.267-1.288 4.455 4.455 0 0 1-.455-2.118 4.951 4.951 0 0 1 .413-2.11 3.139 3.139 0 0 1 1.162-1.358 3.179 3.179 0 0 1 1.743-.476Zm-.014 1.008a1.781 1.781 0 0 0-1.393.567 2.673 2.673 0 0 0-.609 1.575h3.822a2.631 2.631 0 0 0-.448-1.547 1.584 1.584 0 0 0-1.372-.595Zm7.91 6.776a3.756 3.756 0 0 1-1.778-.406 2.855 2.855 0 0 1-1.211-1.26 4.747 4.747 0 0 1-.441-2.184 4.85 4.85 0 0 1 .46-2.254 2.878 2.878 0 0 1 1.253-1.274 3.926 3.926 0 0 1 1.806-.406 5.082 5.082 0 0 1 1.1.119 3.839 3.839 0 0 1 .875.287l-.378 1.022a7.285 7.285 0 0 0-.784-.238 3.472 3.472 0 0 0-.84-.112q-2.212 0-2.212 2.842a3.429 3.429 0 0 0 .539 2.079 1.875 1.875 0 0 0 1.6.721 4.22 4.22 0 0 0 1.078-.126 5.25 5.25 0 0 0 .868-.308v1.092a3.522 3.522 0 0 1-.833.3 4.958 4.958 0 0 1-1.102.106Zm6.1-1.008a4.057 4.057 0 0 0 .574-.042 2.242 2.242 0 0 0 .476-.112v.938a2.1 2.1 0 0 1-.56.161 4.105 4.105 0 0 1-.7.063 2.842 2.842 0 0 1-1.085-.2 1.678 1.678 0 0 1-.805-.707 2.718 2.718 0 0 1-.308-1.414v-4.371H206.5v-.588l1.078-.49.49-1.6h.732v1.73h2.17v.952h-2.17v4.34a1.383 1.383 0 0 0 .329 1.015 1.146 1.146 0 0 0 .845.325Zm5.334-6.776a3.15 3.15 0 0 1 1.652.42 2.745 2.745 0 0 1 1.071 1.183 4.038 4.038 0 0 1 .371 1.785v.742h-5.134a2.832 2.832 0 0 0 .651 1.939 2.272 2.272 0 0 0 1.743.665 5.444 5.444 0 0 0 1.267-.133 7.145 7.145 0 0 0 1.141-.385v1.078a5.844 5.844 0 0 1-1.134.371 6.478 6.478 0 0 1-1.33.119 3.95 3.95 0 0 1-1.89-.434 3.041 3.041 0 0 1-1.267-1.288 4.455 4.455 0 0 1-.455-2.118 4.951 4.951 0 0 1 .41-2.11 3.139 3.139 0 0 1 1.162-1.358 3.179 3.179 0 0 1 1.746-.476Zm-.014 1.008a1.781 1.781 0 0 0-1.393.567 2.673 2.673 0 0 0-.609 1.575h3.822a2.631 2.631 0 0 0-.448-1.547 1.584 1.584 0 0 0-1.368-.595Zm7.56 6.776a2.811 2.811 0 0 1-2.24-.973 4.342 4.342 0 0 1-.84-2.905 4.375 4.375 0 0 1 .847-2.919 3.135 3.135 0 0 1 3.668-.665 3.022 3.022 0 0 1 .9.784h.084q-.028-.182-.056-.539t-.028-.567v-3h1.232V393h-.987l-.182-1.008h-.056a2.906 2.906 0 0 1-.9.812 2.771 2.771 0 0 1-1.438.336Zm.2-1.022a1.952 1.952 0 0 0 1.673-.651 3.293 3.293 0 0 0 .483-1.967v-.224a4.119 4.119 0 0 0-.462-2.149 1.844 1.844 0 0 0-1.708-.749 1.645 1.645 0 0 0-1.491.791 3.952 3.952 0 0 0-.5 2.121 3.726 3.726 0 0 0 .5 2.086 1.689 1.689 0 0 0 1.505.742Z"
//         data-name="Path 101164"
//       />
//     </g>
//   </svg>

// )







